var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342,
    height: 883.375,
    viewBox: "0 0 342 883.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M289.079,815.669c-4.787-22.037-5.844-40.515-2.361-41.271s46.376-.525,51.164,21.511-30.344,57.534-33.827,58.291S293.867,837.706,289.079,815.669Z",
    transform: "translate(-284.666 -774.194)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M470.3,862.8c-11.813,20.359-24.087,35.3-27.415,33.366s-19.51-30.065-7.7-50.424,47.148-25.232,50.476-23.3S482.109,842.444,470.3,862.8Z",
    transform: "translate(-430.93 -822.055)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M325.746,1832.482h65l21.994-28.389,17.515-35.665H322.1Z",
    transform: "translate(-322.096 -1768.428)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M376.663,1828.044c-6.848-14.847-10.5-27.76-8.15-28.843,1.173-.542,6.479-9.97,15.228-9.891s20.941,9.663,24.365,17.086c6.848,14.847-12.447,45.488-14.794,46.571S383.511,1842.891,376.663,1828.044Z",
    transform: "translate(-367.801 -1789.309)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    cx: 5.208,
    cy: 5.208,
    r: 5.208,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 18.201,
    height: 22.486,
    transform: "translate(27.017 6.965) rotate(108.044)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M182.737,1366.93l-166,6.2V1111.714h254l-21.18,56.084-4.6,8.057Z",
    transform: "translate(11.263 -1111.714)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M449.463,1385.338l-201.876-5.255s15.633-25.794,31.9-59.04a554.918,554.918,0,0,0,23.226-53.817c4.739-13.1-16.9-30.9-12.661-43.739,7.828-23.734,36.023-18.256,35.106-40.862-1.726-42.588,31.212-37.408,29.927-65.033-1.151-24.747-13.237-44.891-13.237-44.891l107.62-13.958Z",
    transform: "translate(-247.587 -1062.064)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190-2",
    "data-name": "Path 1190",
    d: "M449.463,1337.793s-186.243,16.5-169.981-16.751a554.918,554.918,0,0,0,23.226-53.817c4.739-13.1-16.9-30.9-12.661-43.739,7.828-23.734,36.023-18.256,35.106-40.862-1.726-42.588,31.212-37.408,29.927-65.033-1.151-24.747-12.428-28.3-12.428-28.3H449.463Z",
    transform: "translate(-247.587 -1062.064)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 10.691,
    cy: 10.691,
    r: 10.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 37.364,
    height: 46.159,
    transform: "translate(46.159 0) rotate(90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1602",
    "data-name": "Rectangle 1602",
    width: 342,
    height: 119,
    transform: "translate(20.5 5566)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(-4.349 -4576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322",
    transform: "translate(0 -115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M3652.928-9591.285v-195",
    transform: "translate(-3533 15027.285)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4305",
    "data-name": "Path 4305",
    d: "M3652.928-9612.855v-173.426",
    transform: "translate(-3465.429 15038.07)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M3652.928-9524.977v-261.3",
    transform: "translate(-3605 14996.355)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 83.545, 4871.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M.629,0,0,.264c7.495,17.867,17.542,28.264,29.864,30.9,19.522,4.182,38.454-12.48,38.64-12.653l-.466-.5C67.855,18.186,49.174,34.606,30,30.5,17.915,27.908,8.032,17.647.629,0Z",
    transform: "translate(29.319 7.986)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(89.424 25.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M6.83,5.9,8.1.282,8.553.77a37.507,37.507,0,0,1-8.2,1.541c-.5.038-.465-.735.027-.773a36.651,36.651,0,0,0,8-1.522c.3-.092.514.227.455.488L7.571,6.124c-.11.486-.85.261-.741-.222Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "translate(280.135 4925.036) rotate(158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046-2",
    "data-name": "Group 1046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019-2",
    "data-name": "Path 1019",
    d: "M.629,31.84,0,31.576C7.495,13.709,17.542,3.312,29.863.674,49.386-3.509,68.317,13.153,68.5,13.327l-.466.5C67.854,13.654,49.173-2.766,30,1.341,17.915,3.931,8.032,14.193.629,31.84Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048-2",
    "data-name": "Group 1048",
    transform: "translate(60.105 8.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047-2",
    "data-name": "Group 1047",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020-2",
    "data-name": "Path 1020",
    d: "M6.83.493,8.1,6.113l.455-.488a37.507,37.507,0,0,0-8.2-1.541c-.5-.038-.465.735.027.773a36.651,36.651,0,0,1,8,1.523c.3.092.514-.227.455-.488L7.571.271c-.11-.486-.85-.261-.741.222Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(99.898 4707.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(57.413 19.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(50.966 133.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M361.185,988.959,332.521,991.2a1.2,1.2,0,0,1-1.2-1.068l-3.45-18.883a1.257,1.257,0,0,1,.992-1.557l32.095-2.512a1.251,1.251,0,0,1,1.223,1.344l.02,19.151A1.208,1.208,0,0,1,361.185,988.959Z",
    transform: "translate(-302.523 -966.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M332.271,991.355a1.54,1.54,0,0,1-1.443-1.337l-3.45-18.883a1.769,1.769,0,0,1,.318-1.4,1.351,1.351,0,0,1,.968-.542l32.095-2.512a1.351,1.351,0,0,1,1.026.372,1.761,1.761,0,0,1,.546,1.3l.02,19.152a1.522,1.522,0,0,1-1.317,1.6l-28.664,2.243C332.337,991.354,332.3,991.355,332.271,991.355Zm28.587-24.026-.049,0-32.094,2.512a.708.708,0,0,0-.5.29,1.133,1.133,0,0,0-.194.885l3.45,18.883a.889.889,0,0,0,.853.8l28.664-2.243a.9.9,0,0,0,.718-.957l-.02-19.152a1.127,1.127,0,0,0-.338-.82A.717.717,0,0,0,360.858,967.329Z",
    transform: "translate(-302.348 -966.68)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(31.755 93.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M305.563,936.682a7.794,7.794,0,0,1-5.68-13.13L314.66,907.82a7.794,7.794,0,1,1,11.362,10.672l-14.777,15.732A7.774,7.774,0,0,1,305.563,936.682Z",
    transform: "translate(-297.77 -905.362)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(77.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 27.714,
    cy: 27.714,
    r: 27.714,
    transform: "translate(0.325 0.326)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M395.713,817.932a28.038,28.038,0,1,1,28.034-29.017h0a28.038,28.038,0,0,1-27.043,29C396.373,817.927,396.042,817.932,395.713,817.932Zm.036-55.428q-.488,0-.979.017a27.389,27.389,0,0,0,.943,54.761q.482,0,.968-.017A27.419,27.419,0,0,0,423.1,788.938h0A27.391,27.391,0,0,0,395.75,762.5Z",
    transform: "translate(-367.687 -761.855)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(65.159 18.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(17.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 44.072,
    height: 0.65,
    transform: "matrix(0.217, -0.976, 0.976, 0.217, 0, 43.024)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0 16.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 0.65,
    height: 45.867,
    transform: "translate(0 0.634) rotate(-77.496)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(3.696 2.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 7.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 44.072,
    height: 0.65,
    transform: "matrix(0.844, -0.537, 0.537, 0.844, 0, 23.667)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(6.169 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 0.65,
    height: 45.867,
    transform: "translate(0 0.349) rotate(-32.496)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(0 6.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(0 1.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M291.684,854.239c-19.2.917-36.956-12.63-41.309-32.665s6.181-39.729,24.033-46.861",
    transform: "translate(-249.06 -774.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M289.614,854.447c-18.99,0-35.528-13.591-39.737-32.967-4.35-20.02,5.84-39.884,24.229-47.231l.241.6c-18.093,7.23-28.117,26.782-23.835,46.491s21.512,33.347,40.976,32.41l.031.649Q290.563,854.447,289.614,854.447Z",
    transform: "translate(-248.879 -774.249)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(18.989 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 6.454,
    cy: 40.832,
    rx: 6.454,
    ry: 40.832,
    transform: "translate(0 2.74) rotate(-12.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M303.675,854.471c-2.33,0-5.119-5.89-7.085-10.949a195.121,195.121,0,0,1-7.991-27.862c-4.3-19.77-6.259-40.757-2.112-41.658,2.384-.511,5.323,5.651,7.37,10.917a221.736,221.736,0,0,1,12.28,56.528c.323,5.641.207,12.474-2.177,12.992A1.363,1.363,0,0,1,303.675,854.471Zm-16.912-79.848a.64.64,0,0,0-.138.014c-2.893.629-2.535,17.207,2.609,40.886a194.514,194.514,0,0,0,7.962,27.764c3.978,10.232,6.075,10.638,6.628,10.518s2.293-1.36,1.666-12.32a221.112,221.112,0,0,0-12.237-56.33C289.553,775.642,287.477,774.623,286.762,774.623Z",
    transform: "translate(-280.247 -772.95)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(71.397 107.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    d: "M0,0H32.156a0,0,0,0,1,0,0V1.368A16.078,16.078,0,0,1,16.078,17.446h0A16.078,16.078,0,0,1,0,1.368V0A0,0,0,0,1,0,0Z",
    transform: "matrix(0.986, -0.169, 0.169, 0.986, 0, 5.424)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(71.397 69.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(24.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M406.489,895.309a4.72,4.72,0,0,1-1.664-.27,11.858,11.858,0,0,1-2.924-1.8q-.132.213-.272.427l-.543-.357q.162-.247.311-.493a15.032,15.032,0,0,1-3.033-3.51c-.7-1.217-2.882-5.388-1.753-7.979a3.442,3.442,0,0,1,6.108-.234c1.661,2.379,2.135,6.917-.489,11.584a11.348,11.348,0,0,0,2.835,1.762,5.1,5.1,0,0,0,3.319-.112c1.919-.694,3.419-2.367,4.459-4.973,1.143-2.864,2.267-5.779,3.193-8.465-.8-1.289-1.261-2.1-1.273-2.119h0c-.144-.287-2.688-5.42-1.373-8.236a2.975,2.975,0,0,1,2.146-1.666,2.572,2.572,0,0,1,2.735.537c1.159,1.348.75,4.73-1.526,11.4a84.846,84.846,0,0,0,5.735,8.06l-.5.409a84.743,84.743,0,0,1-5.5-7.684c-.8,2.289-1.807,4.945-3.029,8.008-1.384,3.47-3.4,4.821-4.841,5.343A6.224,6.224,0,0,1,406.489,895.309Zm-6.7-15.336a2.216,2.216,0,0,0-.5.058,2.746,2.746,0,0,0-2.078,1.553c-.8,1.838.364,5.026,1.722,7.4a14.187,14.187,0,0,0,2.8,3.265c2.419-4.381,1.994-8.586.461-10.783A3.03,3.03,0,0,0,399.788,879.973Zm15.559-1.494c.078.136.413.72.961,1.611,1.663-4.958,2.557-9,1.474-10.265-.394-.458-1.079-.565-2.1-.328a2.327,2.327,0,0,0-1.7,1.308c-1.192,2.553,1.341,7.623,1.367,7.673Z",
    transform: "translate(-396.294 -868.725)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(0 24.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M376.788,938.085l-.611-.222A22.664,22.664,0,0,0,373.363,917c-6.331,1.375-11.134-.776-13.258-3.238-1.461-1.694-1.711-3.531-.65-4.794a3.339,3.339,0,0,1,2.491-1.229c3.483-.169,7.934,4.148,8.121,4.332a24.806,24.806,0,0,1,3.583,4.2,24.8,24.8,0,0,0,7.142-3.065,22.426,22.426,0,0,0,7.154-6.635l.543.357a23.069,23.069,0,0,1-7.358,6.832,25.568,25.568,0,0,1-7.1,3.083A23.246,23.246,0,0,1,376.788,938.085Zm-14.638-29.7c-.058,0-.116,0-.173,0a2.682,2.682,0,0,0-2.025,1c-.84,1-.594,2.516.644,3.952,1.982,2.3,6.446,4.291,12.37,3.084a24.023,24.023,0,0,0-3.338-3.875C369.569,912.493,365.35,908.385,362.15,908.385Z",
    transform: "translate(-358.804 -906.572)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(56.633 47.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 5.384,
    cy: 5.384,
    r: 5.384,
    transform: "translate(0.325 0.327)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M341.794,846.1a5.787,5.787,0,0,1-1.247-.137,5.709,5.709,0,1,1,6.81-4.338h0a5.715,5.715,0,0,1-5.563,4.475Zm-.012-10.771a5.06,5.06,0,1,0,4.94,6.155h0a5.063,5.063,0,0,0-4.94-6.155Z",
    transform: "translate(-336.074 -834.676)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(23.244 8.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(-10.09 11.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M290.419,837.453a27.44,27.44,0,0,1-21.288-10.146l11.607-9.4a12.327,12.327,0,0,0,6.978,4.312,12.464,12.464,0,0,0,11.735-20.752L310.3,791.189a27.405,27.405,0,0,1-19.876,46.264Z",
    transform: "translate(-269.131 -791.189)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(118.242 35.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(5.926 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(5.963 3.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M492.044,822.832A43.036,43.036,0,0,1,449.412,896.3",
    transform: "translate(-449.296 -822.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M464.631,899.3a43.14,43.14,0,0,1-15.4-2.833l.231-.607a42.711,42.711,0,0,0,42.311-72.914l.412-.5A43.36,43.36,0,0,1,464.631,899.3Z",
    transform: "translate(-449.234 -822.445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 42.619,
    cy: 6.967,
    rx: 42.619,
    ry: 6.967,
    transform: "matrix(0.502, -0.865, 0.865, 0.502, 0, 73.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M449.371,896.6a1.6,1.6,0,0,1-.819-.208c-3.948-2.291,4.652-22.545,15.246-40.8a197.054,197.054,0,0,1,16.92-25.084c3.743-4.556,8.682-9.709,10.94-8.4,3.947,2.291-4.652,22.545-15.246,40.8h0A197.04,197.04,0,0,1,459.491,888C456.151,892.061,451.862,896.6,449.371,896.6ZM490.8,822.541c-1.7,0-5.186,3.032-9.581,8.381a196.46,196.46,0,0,0-16.86,25c-12.7,21.882-18.256,38.3-15.482,39.915,1.413.822,5.193-2.263,10.111-8.249a196.425,196.425,0,0,0,16.86-25h0c12.7-21.882,18.257-38.305,15.483-39.915A1.043,1.043,0,0,0,490.8,822.541Z",
    transform: "translate(-442.689 -818.894)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0 3.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(16.361 15.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M476.492,846.76a20.491,20.491,0,0,1-20.166,35.471",
    transform: "translate(-456.192 -846.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M464.7,884.243a20.78,20.78,0,0,1-8.582-1.859l.268-.592a20.167,20.167,0,0,0,19.847-34.909l.372-.533a20.833,20.833,0,0,1-11.9,37.893Z",
    transform: "translate(-456.12 -846.35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(13.371 14.499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 20.351,
    cy: 3.244,
    rx: 20.351,
    ry: 3.244,
    transform: "matrix(0.502, -0.865, 0.865, 0.502, 0, 35.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M455.767,882.281a.869.869,0,0,1-.471-.136c-2.264-1.315,3.119-12.487,7.29-19.675a96.614,96.614,0,0,1,8.073-12.012c3.988-4.893,5.043-4.28,5.391-4.08s1.4.814-.868,6.7a109.732,109.732,0,0,1-14.5,24.982C457.761,881.655,456.414,882.281,455.767,882.281Zm19.81-35.374c-.505,0-1.853.82-4.414,3.962a95.97,95.97,0,0,0-8.015,11.928c-6.227,10.732-8.58,18.174-7.526,18.786.342.2,1.689-.4,4.561-3.928a109.093,109.093,0,0,0,14.394-24.8c1.634-4.242,1.49-5.71,1.148-5.909A.293.293,0,0,0,475.576,846.907Z",
    transform: "translate(-452.653 -845.032)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(14.532 5.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M453.648,897.313l-.346-.55c5.205-3.272,15.3-16.693,24.554-32.636,9.483-16.342,16.128-31.9,16.159-37.828l.65,0c-.032,6.033-6.713,21.721-16.246,38.15C468.972,880.733,459.018,893.939,453.648,897.313Z",
    transform: "translate(-453.303 -826.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(15.821 27.98)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 6.489,
    cy: 6.489,
    r: 6.489
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(189.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M466.761,738.922c-4.206,2.87-11.316,8.7-8.052,14.588,2.331,4.209,8.356,3.913,12.02,1.982,4.673-2.462,8.653-9.347,6.779-14.621-1.613-4.541-7.348-5.61-11.552-5.388-4.7.25-10.161,2.275-12.434,6.687a7.916,7.916,0,0,0,6.138,11.453c5.8.818,12.993-2.451,16.245-7.311,3.333-4.982,1.3-11.007-4.226-13.151-7.261-2.816-19.282,1.246-16.429,10.74a.525.525,0,0,0,1-.321c-2.268-7.552,6.122-10.914,12.29-10.132,3.1.394,6.208,1.961,7.485,4.954,1.407,3.3-.113,6.657-2.438,9.057-3.961,4.087-14.163,8.278-18.536,2.608a7.416,7.416,0,0,1-.036-8.373c1.482-2.254,4.148-3.586,6.638-4.376,4.066-1.287,9.5-1.394,13.011,1.381,4.5,3.559,1.422,10.428-1.712,13.771-3.059,3.264-8.925,4.878-12.527,1.533-5.184-4.815,3.42-11.824,6.9-14.2.559-.381,0-1.268-.564-.885Z",
    transform: "translate(-452.625 -732.285)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(205.996 28.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0.693 0.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M496.68,806.434l-.968-.108c2.157-19.371-16.809-27.97-17-28.055l.392-.892C479.3,777.468,498.917,786.343,496.68,806.434Z",
    transform: "translate(-478.711 -777.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M482.589,776.745l-4.65.191a.315.315,0,0,0-.247.48,29.594,29.594,0,0,1,2.861,5.923c.133.378.729.19.595-.191a30.324,30.324,0,0,0-2.929-6.068l-.247.48,4.65-.191a.313.313,0,0,0-.032-.624Z",
    transform: "translate(-477.644 -776.744)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(142.942 152.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(13.625 6.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M318.952,987.052c-9.88-3.811-19.764,10.547-10.3,17.157,6.673,4.661,22.224,4.891,24.323-5.114,1.1-5.234-2.226-10.306-6.55-12.911-4.7-2.834-10.78-3.287-16.037-2.019-5.014,1.211-10.625,5.041-10.929,10.641-.293,5.408,5.134,9.45,9.63,11.129a18.706,18.706,0,0,0,8.4.958,31.961,31.961,0,0,0,9.468-2.082,10.108,10.108,0,0,0,6-5.935c1.022-3.162.044-6.22-1.969-8.753-3.779-4.761-9.735-5.942-15.478-5-4.989.822-10.362,3.509-12.123,8.56-1.767,5.067,1.326,10.6,6.228,12.3,5.419,1.885,11.779.782,16.92-1.465,4.035-1.764,8.844-5.495,8.206-10.447-.562-4.375-5.154-7.152-8.9-8.527-6.722-2.466-14.818-1.161-18.46,5.573a.389.389,0,0,0,.687.364c3.355-6.206,10.461-7.345,16.712-5.476,4.226,1.263,9.97,4.767,9.167,9.944-.437,2.818-2.929,5.078-5.2,6.533a24.563,24.563,0,0,1-8.227,3.123c-5.71,1.194-13.64.779-16.144-5.507-2.621-6.575,2.692-11.676,8.5-13.552,6.31-2.038,13.434-1.085,17.724,4.319a8.076,8.076,0,0,1-.22,10.784c-2.427,2.638-6.479,3.544-9.869,4.088a23.65,23.65,0,0,1-9.405.005,17.083,17.083,0,0,1-8.093-4.583,8.538,8.538,0,0,1-2.574-7.818c.729-3.227,3.738-5.684,6.543-7.123,5.3-2.721,12.226-2.551,17.592-.133,5.235,2.358,9.544,8.533,7.181,14.373-2.046,5.058-8.711,6.192-13.5,5.959-5.525-.268-12.762-2.975-12.715-9.539.043-6.3,7.151-11.424,13.049-9.148.461.179.829-.506.363-.687Z",
    transform: "translate(-299.445 -983.493)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(46.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M349.834,981.536a.325.325,0,0,1-.239-.544l6.987-7.61a.325.325,0,1,1,.478.439l-6.987,7.61A.325.325,0,0,1,349.834,981.536Z",
    transform: "translate(-349.509 -973.276)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(50.115 8.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M355.95,988.938a.325.325,0,0,1-.079-.64l6.191-1.551a.325.325,0,0,1,.158.63l-6.19,1.55A.309.309,0,0,1,355.95,988.938Z",
    transform: "translate(-355.626 -986.738)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(0 26.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M278.792,1021.091a.325.325,0,0,1-.154-.611l11.171-5.994a.325.325,0,0,1,.307.572l-11.17,5.994A.321.321,0,0,1,278.792,1021.091Z",
    transform: "translate(-278.467 -1014.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(13.678 27.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M299.851,1025.766a.318.318,0,0,1-.1-.017.325.325,0,0,1-.2-.411l2.949-8.805a.325.325,0,1,1,.616.207l-2.949,8.805A.325.325,0,0,1,299.851,1025.766Z",
    transform: "translate(-299.526 -1016.312)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(41.997 30.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M346.32,1030.9a.324.324,0,0,1-.312-.236l-2.868-10.137a.325.325,0,1,1,.625-.177l2.868,10.137a.324.324,0,0,1-.223.4A.332.332,0,0,1,346.32,1030.9Z",
    transform: "translate(-343.128 -1020.108)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(45.964 29.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M354.649,1022.006a.319.319,0,0,1-.181-.055l-5.089-3.418a.325.325,0,0,1,.362-.539l5.088,3.418a.325.325,0,0,1-.181.594Z",
    transform: "translate(-349.236 -1017.938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(48.652 26.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M358.032,1015.384h-.018l-4.333-.231a.324.324,0,0,1-.307-.341.328.328,0,0,1,.341-.308l4.334.231a.325.325,0,0,1-.017.649Z",
    transform: "translate(-353.373 -1014.504)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(199.897 4.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M470.69,750.7a.512.512,0,0,1,.116.258.668.668,0,0,1-.21.52.809.809,0,0,1-.492.3q-.554.067-.924-.6-.24-.431,0-.681a1.081,1.081,0,0,1,.785-.128A.951.951,0,0,1,470.69,750.7Zm2.23-9.938a3.809,3.809,0,0,1,.229.909,5.5,5.5,0,0,1-.619,2.935q-.7,1.4-1.385,2.788l-.3.887a.932.932,0,0,1-.626.6q-.844.2-.857-.186a8.4,8.4,0,0,1,1.139-3.644,9.273,9.273,0,0,0,1.194-3.6.674.674,0,0,0-.156-.45.434.434,0,0,0-.411-.163q-.218.026-.513.4-.2.348-.641,1.048a3.4,3.4,0,0,0-.19.977.555.555,0,0,1-.6.564.765.765,0,0,1-.869-.577,2.06,2.06,0,0,1-.049-.266,2.394,2.394,0,0,1,.452-1.62,9.525,9.525,0,0,1,1.122-1.293,1.68,1.68,0,0,1,1.024-.549,2.21,2.21,0,0,1,1.242.277A1.724,1.724,0,0,1,472.92,740.762Z",
    transform: "translate(-468.253 -739.521)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(82.658 4785.846) rotate(-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M2.321,1.777a4.182,4.182,0,0,0,.044.5c.021.1.074.227.224.208.1-.012.2-.063.2-.167.018-.462.433-.593.7-.837A3.013,3.013,0,0,1,7.078.97a1.058,1.058,0,0,1,.664.973c.005.125-.006.294.154.334s.222-.118.309-.209a.724.724,0,0,0,.2-.273C8.734.568,9.783.693,10.683.611a22.943,22.943,0,0,1,3.708.067A.957.957,0,0,1,14.546.7c-.044.52.61.793.492,1.309-.107.465-.56.474-.938.6a8.245,8.245,0,0,1-2.92.5c-.29-.013-.5.21-.592.526A6.178,6.178,0,0,0,10.5,4.81a.356.356,0,0,0,.318.408c.552.069,1.135.4,1.633-.164a.4.4,0,0,1,.48-.062,1.407,1.407,0,0,1,.958,1.027,1.29,1.29,0,0,1-.7,1.375,3.661,3.661,0,0,1-1.752.542c-.114,0-.262.028-.266.159-.013.386.339.568.522.846a.392.392,0,0,0,.55.135,1.3,1.3,0,0,1,1.69.226c.573.549.669,1.024.079,1.524a3.116,3.116,0,0,1-2.01.935,1.3,1.3,0,0,1-.945-.292A5.831,5.831,0,0,1,9.281,9.175,6.789,6.789,0,0,0,8.166,6.909c-.241-.285-.347-.319-.609.06a44.4,44.4,0,0,1-3.142,4.2.537.537,0,0,1-.672.143c-.483-.253-.967-.526-1.065-1.155-.033-.213-.01-.506-.275-.576-.231-.061-.345.2-.489.333A.961.961,0,0,1,.378,9.731,2.1,2.1,0,0,1,.016,8.237,27.181,27.181,0,0,0,.423,4.36,35.4,35.4,0,0,1,.6.47c.037-.492.28-.524.639-.424A1.655,1.655,0,0,1,2.321,1.777ZM5.7,2.955c0-.4-.107-.485-.407-.326a3.215,3.215,0,0,0-1.04.84,7.453,7.453,0,0,0-1.8,5.075c.007.143-.116.4.11.445s.3-.2.365-.364c.554-1.323,1.525-2.4,2.133-3.7A9.727,9.727,0,0,0,5.7,2.955Z",
    transform: "translate(10.473 21.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M.056,10.526A14.559,14.559,0,0,1,.669,6.714,17.826,17.826,0,0,1,1.777,3.052q.445-.992.875-1.99A1.548,1.548,0,0,1,4.99.274C6.073.935,6.232,2,6.666,2.971c.659,1.48.931,3.084,1.492,4.6A1.8,1.8,0,0,0,9.392,8.7a2.361,2.361,0,0,1,1.117.822.78.78,0,0,1-.3,1.229c-.051.024-.109.031-.162.051a4.1,4.1,0,0,0-1.871,1.371,1.31,1.31,0,0,1-1.739.217A25.6,25.6,0,0,1,3.725,10.4c-.284-.2-.581-.6-.914-.441-.363.173-.266.639-.253,1.023A1.614,1.614,0,0,1,2,12.369a1.172,1.172,0,0,1-1.248.309A1.323,1.323,0,0,1,0,11.436,8.7,8.7,0,0,1,.056,10.526Zm5.31-3.009c.484.07.669-.046.493-.581A32.243,32.243,0,0,0,4.712,3.592c-.067-.146-.091-.38-.291-.375A.517.517,0,0,0,4,3.567a9.973,9.973,0,0,0-.81,3.321c-.006.267.084.358.323.425A18.407,18.407,0,0,0,5.366,7.518Z",
    transform: "translate(28.041 19.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M0,9.992c.291-1.5.261-3.115.652-4.668.289-1.149.557-2.3.893-3.439C1.806,1,2.011.816,2.816.868A1.222,1.222,0,0,0,3.748.3.813.813,0,0,1,4.367,0,2.154,2.154,0,0,1,6.14,1.184,40.33,40.33,0,0,1,7.715,6.15a.639.639,0,0,0,.7.578,4.054,4.054,0,0,1,1.728.217c.2.1.422.185.376.488a.531.531,0,0,1-.47.5c-.566.057-.96.485-1.483.632-.339.1-.312.408-.332.7a1.955,1.955,0,0,1-.814,1.628.747.747,0,0,1-1.109-.1c-.554-.707-1.328-1.176-1.91-1.844a1.633,1.633,0,0,0-1.12-.457.268.268,0,0,0-.33.233,9.092,9.092,0,0,0-.43,1.8c0,.624-.435.975-.821,1.359a.406.406,0,0,1-.477.051A2.026,2.026,0,0,1,0,9.992ZM3.522,5.467c0,.316.029.62.414.63a6.818,6.818,0,0,1,1.106.21c.554.106.712-.043.542-.6-.265-.859-.574-1.7-.874-2.552-.076-.216-.174-.339-.378-.063A8.9,8.9,0,0,0,3.522,5.467Z",
    transform: "translate(26.97 1.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M6.476,2.887a3.587,3.587,0,0,1-1.33,2.856c-.454.4-.785.975-1.505,1.014C3.411,6.77,3.4,7,3.526,7.2c.781,1.267,1.552,2.541,2.342,3.8.278.445.554.442.885.028.106-.133.19-.285.3-.412.129-.148.222-.4.487-.3a.525.525,0,0,1,.356.588,4.73,4.73,0,0,1-.7,2.394.911.911,0,0,1-1.243.108,5.567,5.567,0,0,1-2.286-1.956c-.23-.439-.5-.874-.736-1.318-.068-.127-.126-.321-.31-.263-.152.048-.082.223-.086.352a9.963,9.963,0,0,1-.063,1.13.831.831,0,0,1-.784.7,1.253,1.253,0,0,1-1.112-.53C.035,10.961.17,10.215.1,9.553A20.029,20.029,0,0,1,.17,5,5.587,5.587,0,0,0,.192,3.752,6.88,6.88,0,0,1,.726.609C.972-.056,1.266-.172,1.815.24A1.477,1.477,0,0,0,3.16.5a2.889,2.889,0,0,1,2.712.588A2.359,2.359,0,0,1,6.476,2.887ZM4.507,2.823a.335.335,0,0,0-.385-.349,1.163,1.163,0,0,0-1.078.6,15.174,15.174,0,0,0-.519,1.432.323.323,0,0,0,.049.373c.123.109.261.021.359-.056A7.727,7.727,0,0,0,4.435,3.3C4.508,3.2,4.521,3.094,4.507,2.823Z",
    transform: "translate(11.575 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M2.259,6.193a.243.243,0,0,0,.235-.141c.427-.686,1.053-.621,1.736-.526a47.04,47.04,0,0,0,5.211.542,1.918,1.918,0,0,1,1.016.275,1.113,1.113,0,0,1,0,1.987,1.182,1.182,0,0,1-1.3.166,6.9,6.9,0,0,0-1.582-.39c-.343-.088-.456.073-.325.349a3.1,3.1,0,0,1-.058,2.105c-.178.792-.952,1.057-1.608,1.374a6.446,6.446,0,0,1-.7.2,2.308,2.308,0,0,1-2.762-.761,11.661,11.661,0,0,1-1.4-1.96A5.923,5.923,0,0,1,0,6.609,11.6,11.6,0,0,1,.877,2.445a4.965,4.965,0,0,1,1.91-2.3A1.5,1.5,0,0,1,4.154.2a.589.589,0,0,1-.038,1.026A2.216,2.216,0,0,0,3.226,2.55a4.952,4.952,0,0,1-.31.53,10.858,10.858,0,0,0-.781,2.588A.546.546,0,0,0,2.259,6.193Zm.024.689c-.43.689.088,1.226.347,1.755.508,1.036,1.109,1.58,2.3,1.125a.516.516,0,0,0,.365-.542A1.516,1.516,0,0,0,3.832,7.8a1.277,1.277,0,0,1-1.294-.716C2.489,6.99,2.424,6.883,2.282,6.882Z",
    transform: "translate(0 0.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M2.588.085a10.222,10.222,0,0,1,3.1.155c.38.035.686.214.7.6s-.257.567-.65.72a13.252,13.252,0,0,1-2.52.7c-.339.06-.448.383-.462.7a10.336,10.336,0,0,1,.072,1.855c-.068.312.3.262.454.168.482-.3.8-.1,1.035.3a1.065,1.065,0,0,1-.164,1.4c-.314.2-.48.526-.757.754s-.094.5,0,.719A9.679,9.679,0,0,0,4.066,9.4c.258.414.57.66,1.122.394.315-.151.774-.284.96.225.164.45.576.841.019,1.41a2.117,2.117,0,0,1-3.361-.08,6.49,6.49,0,0,1-1.7-2.833C.869,7.551.392,6.7.078,5.783c-.1-.3-.123-.648.055-.807.5-.445.312-1.015.384-1.53.075-.539.052-1.091.1-1.636C.712.566,1.195.112,2.588.085Z",
    transform: "translate(19.207 1.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M2,.056C3.577-.184,5.064.4,6.581.75a5.512,5.512,0,0,1,1.929.894,1.066,1.066,0,0,1,.445,1.285,1.417,1.417,0,0,1-1.582.392A5.945,5.945,0,0,0,5.621,2.9c-.3-.042-.461.037-.407.445.167,1.253-.12,2.505-.062,3.764a17.164,17.164,0,0,0,.221,3.319,1.242,1.242,0,0,1-.426,1.214.887.887,0,0,1-1.133.218,1.379,1.379,0,0,1-.728-1.185,28.867,28.867,0,0,0-.55-5.149,1.148,1.148,0,0,1,.217-.855c.415-.613.123-1.268.185-1.9.041-.412-.353-.343-.634-.322A2.083,2.083,0,0,1,.124,1.268.715.715,0,0,1,.736.131,3.242,3.242,0,0,1,2,.056Z",
    transform: "translate(36.176 1.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M2.182,1.845c.052,1.025-.008,2.267-.043,3.508a2.272,2.272,0,0,0,.145.948,1.985,1.985,0,0,1-.6,2.386.614.614,0,0,1-.875.035,2.257,2.257,0,0,1-.78-1.449C-.1,5.1.218,2.938.218.767c0-.609.328-.838.925-.749C2.179.172,2.222.239,2.182,1.845Z",
    transform: "translate(5.517 22.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M1.2,0A.984.984,0,0,1,2.12,1.116a2.64,2.64,0,0,1-.457,1.137c-.183.257-.363.5-.725.392s-.714-.25-.781-.705C.121,1.7.045,1.463.017,1.222-.085.347.261-.005,1.2,0Z",
    transform: "translate(7.505 19.705)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(-11.651 -48.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523",
    transform: "translate(228.346 5245.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    transform: "translate(7.492 73.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M326.082,1882.184a5.178,5.178,0,0,1,1.881,7.076c-2.456,4.233-4.652,10.242-6.4,16.018a5.176,5.176,0,0,1,7.681,6.895c-3.65,4.754-3.115,17.415-3.115,17.415a8.791,8.791,0,0,1-17.4,1.791l-.031-.009c-2.09-5.916-2.286-7.656-2.286-8.8,0-2.632,1.954-10.339,3.771-16.386,1.963-6.533,5.086-15.674,8.822-22.115A5.176,5.176,0,0,1,326.082,1882.184Z",
    transform: "translate(-306.089 -1881.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M317.162,1938.524a9.143,9.143,0,0,1-8.9-7.138l-.046-.086c-2.126-6.019-2.3-7.756-2.3-8.911,0-2.67,1.962-10.414,3.785-16.48,1.968-6.552,5.1-15.718,8.852-22.185a5.5,5.5,0,0,1,9.518,5.52A75.518,75.518,0,0,0,322,1904.21a5.542,5.542,0,0,1,6.312.271,5.5,5.5,0,0,1,1.013,7.714c-3.537,4.606-3.053,17.077-3.047,17.2A9.128,9.128,0,0,1,317.162,1938.524Zm-8.386-7.6.027.008.071.2a8.466,8.466,0,0,0,16.754-1.726c-.022-.508-.5-12.82,3.182-17.613a4.851,4.851,0,0,0-.894-6.8,4.878,4.878,0,0,0-6.3.341l-.895.858.359-1.186a78.948,78.948,0,0,1,6.431-16.087,4.852,4.852,0,0,0-8.395-4.869c-3.719,6.412-6.833,15.527-8.792,22.046-1.81,6.022-3.757,13.689-3.757,16.293C306.564,1923.482,306.736,1925.132,308.776,1930.926Z",
    transform: "translate(-305.914 -1880.982)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    transform: "translate(9.487 22.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M321.013,1929.931a26.718,26.718,0,0,1,5.136-12,5.176,5.176,0,0,1,7.258-.953",
    transform: "translate(-320.693 -1915.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M321.16,1929.809l-.64-.108a27.067,27.067,0,0,1,5.2-12.142,5.5,5.5,0,0,1,7.713-1.013l-.4.515a4.853,4.853,0,0,0-6.8.894A26.43,26.43,0,0,0,321.16,1929.809Z",
    transform: "translate(-320.52 -1915.407)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(0 131.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(0 3.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M340.321,2063.043l-29.146-1.75c1.335-14.279-2.636-22.05-7.234-31.048-6.774-13.257-14.452-28.284-5.505-60.012l28.509,5.165c-6.915,24.522-1.837,34.461,4.044,45.969C336.231,2031.624,342.172,2043.25,340.321,2063.043Z",
    transform: "translate(-294.38 -1970.232)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(77.697 3.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M414.35,2063.043c-1.85-19.792,4.09-31.419,9.332-41.678,5.881-11.508,10.958-21.447,4.044-45.969l28.508-5.165c8.948,31.728,1.27,46.755-5.5,60.012-4.6,9-8.569,16.769-7.233,31.048Z",
    transform: "translate(-414.004 -1970.232)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(3.624 87.51)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 63.015,
    cy: 10.424,
    rx: 63.015,
    ry: 10.424
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(15.54 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476",
    transform: "translate(5.787 34.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M327.716,1851.728l21.994-28.389V1860.4l-21.969,21.969Z",
    transform: "translate(-327.391 -1822.39)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M327.241,1882.644l-.025-31.539,22.644-29.227v38.147Zm.624-31.316.024,29.749,21.321-21.32v-35.979Z",
    transform: "translate(-327.216 -1821.878)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(21.994 0.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 64.997,
    height: 61.238,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M426.725,1884.728H361.079V1822.84h65.646Zm-65-.65h64.347V1823.49H361.728Z",
    transform: "translate(-361.079 -1822.84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474",
    transform: "translate(0 29.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 64.997,
    height: 61.238,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M392.863,1928.436H327.216v-61.888h65.647Zm-65-.649h64.348V1867.2H327.866Z",
    transform: "translate(-327.216 -1866.548)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(65.062 61.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    y1: 28.389,
    x2: 21.994,
    transform: "translate(0.259 0.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 35.912,
    height: 0.649,
    transform: "matrix(0.613, -0.79, 0.79, 0.613, 0, 28.385)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512",
    transform: "translate(2.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    transform: "translate(17.608 13.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(38.787 0.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(16.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 0.65,
    height: 31.954
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(0 15.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 33.255,
    height: 0.65
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482",
    transform: "translate(4.64 3.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(0.46 0.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 31.954,
    height: 0.649,
    transform: "translate(0 22.595) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 0.649,
    height: 33.255,
    transform: "translate(0 0.459) rotate(-45)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486",
    transform: "translate(0 7.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    transform: "translate(0 1.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M386.956,1858.252c-13.447,3.663-28.142-3.139-34.368-16.638s-1.861-29.092,9.655-36.943",
    transform: "translate(-349.396 -1804.403)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M379.291,1859.434a30.141,30.141,0,0,1-27.188-17.829c-6.24-13.529-2.132-29.235,9.767-37.347l.366.536c-11.636,7.933-15.65,23.3-9.543,36.538s20.4,20.163,33.988,16.46l.171.627A28.75,28.75,0,0,1,379.291,1859.434Z",
    transform: "translate(-349.207 -1804.258)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(8.539 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 4.68,
    cy: 29.605,
    rx: 4.68,
    ry: 29.605,
    transform: "matrix(0.908, -0.419, 0.419, 0.908, 0, 3.92)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M392.8,1858.488c-1.39,0-3.6-2.249-6.571-6.7a160.874,160.874,0,0,1-17.578-38.111c-1.634-5.783-1.786-9.027-.451-9.643,2.953-1.362,11,11.908,17.08,25.083a141.611,141.611,0,0,1,7.541,19.631c1.634,5.783,1.785,9.027.45,9.643A1.113,1.113,0,0,1,392.8,1858.488Zm-24.076-53.918a.586.586,0,0,0-.251.052c-.729.336-.9,2.845.8,8.876a160.242,160.242,0,0,0,17.493,37.926c3.481,5.212,5.5,6.71,6.23,6.374s.9-2.845-.8-8.877a140.809,140.809,0,0,0-7.505-19.535C377.756,1814.349,370.918,1804.57,368.724,1804.57Z",
    transform: "translate(-364.088 -1802.367)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(36.107 41.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 3.904,
    cy: 3.904,
    r: 3.904,
    transform: "translate(0.325 0.324)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M409.028,1861.575a4.229,4.229,0,1,1,4.228-4.229A4.234,4.234,0,0,1,409.028,1861.575Zm0-7.808a3.579,3.579,0,1,0,3.579,3.579A3.583,3.583,0,0,0,409.028,1853.768Z",
    transform: "translate(-404.799 -1853.118)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490",
    transform: "translate(12.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    transform: "translate(-11.727 1.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M363.38,1831.507a21.99,21.99,0,0,1-13.634-4.756l9.3-11.693a6.9,6.9,0,0,0,4.338,1.511,6.983,6.983,0,0,0,3.9-12.776l8.363-12.379a21.922,21.922,0,0,1-12.261,40.093Z",
    transform: "translate(-349.746 -1791.414)",
    fill: "#ff3900"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    transform: "translate(28.135 27.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 43.785,
    height: 56.486,
    transform: "translate(17.821 0.325) rotate(18.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M407.371,1878.583a.32.32,0,0,1-.1-.015l-41.632-13.562a.326.326,0,0,1-.209-.41l17.5-53.708a.326.326,0,0,1,.409-.208l41.632,13.562a.325.325,0,0,1,.208.409l-17.5,53.708A.324.324,0,0,1,407.371,1878.583Zm-41.223-14.094,41.014,13.36,17.295-53.09L383.444,1811.4Z",
    transform: "translate(-365.415 -1810.664)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(13.429 6.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494",
    transform: "translate(15.969 22.903)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    cx: 5.208,
    cy: 5.208,
    r: 5.208,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495",
    transform: "translate(0 3.759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 18.201,
    height: 22.486,
    transform: "translate(27.017 6.965) rotate(108.044)",
    fill: "#fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    transform: "translate(4.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M394.194,1825.218a8.376,8.376,0,0,1,3.331-4.377l2.247,3.4a4.23,4.23,0,0,0-1.7,2.24,4.277,4.277,0,0,0,6.7,4.7l2.5,3.215a8.351,8.351,0,0,1-13.076-9.172Z",
    transform: "translate(-393.783 -1820.841)",
    fill: "#ffc0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(15.969 22.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    transform: "translate(-15.969 -19.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 18.201,
    height: 22.486,
    transform: "translate(27.017 6.965) rotate(108.044)",
    fill: "#fffaf0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(0 3.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    transform: "translate(4.996 -3.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M394.194,1825.218a8.376,8.376,0,0,1,3.331-4.377l2.247,3.4a4.23,4.23,0,0,0-1.7,2.24,4.277,4.277,0,0,0,6.7,4.7l2.5,3.215a8.351,8.351,0,0,1-13.076-9.172Z",
    transform: "translate(-393.783 -1820.841)",
    fill: "#ff3900"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509",
    transform: "translate(7.423 37.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(2.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M409.035,1878.084a.34.34,0,0,1-.1-.016l-28.186-9.182a.325.325,0,0,1,.2-.618l28.187,9.183a.325.325,0,0,1-.1.633Z",
    transform: "translate(-380.523 -1868.252)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507",
    transform: "translate(1.195 3.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M407.2,1883.731a.342.342,0,0,1-.1-.015l-28.186-9.183a.325.325,0,1,1,.2-.618L407.3,1883.1a.324.324,0,0,1-.1.633Z",
    transform: "translate(-378.684 -1873.899)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(0 7.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M393.079,1885.38a.321.321,0,0,1-.1-.015l-15.911-5.183a.325.325,0,1,1,.2-.617l15.911,5.183a.325.325,0,0,1-.1.633Z",
    transform: "translate(-376.843 -1879.548)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513",
    transform: "translate(0 63.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M324.652,1867.048l-5.678,19.264h67.819l2.856-19.264Z",
    transform: "translate(-318.54 -1866.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M386.838,1886.461H318.306l5.869-19.913h65.616Zm-67.664-.65h67.1l2.76-18.614H324.661Z",
    transform: "translate(-318.306 -1866.548)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516",
    transform: "translate(70.616 35.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M427.788,1851.728l21.994-28.389,17.515,9.485-19.754,29.392Z",
    transform: "translate(-427.295 -1822.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M447.382,1862.416l-20.353-10.807,22.4-28.911,18.072,9.787ZM428.014,1851.4l19.156,10.171,19.392-28.853-16.958-9.184Z",
    transform: "translate(-427.029 -1822.698)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522",
    transform: "translate(94.765 75.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M449.794,1886.008a5.177,5.177,0,0,0-3.107,6.629c1.666,4.6,2.762,10.906,3.458,16.9a5.176,5.176,0,0,0-8.782,5.423c2.749,5.325-.025,17.69-.025,17.69a8.791,8.791,0,0,0,16.8,4.849l.032,0c3.107-5.452,3.609-7.13,3.811-8.257.467-2.59-.088-10.522-.8-16.795-.772-6.778-2.225-16.328-4.758-23.329A5.176,5.176,0,0,0,449.794,1886.008Z",
    transform: "translate(-440.46 -1885.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M449.8,1943.146a9.114,9.114,0,0,1-8.96-10.73c.03-.136,2.718-12.325.055-17.484a5.5,5.5,0,0,1,2.366-7.411,5.543,5.543,0,0,1,6.26.853,75.56,75.56,0,0,0-3.318-15.8,5.5,5.5,0,0,1,3.3-7.045h0a5.5,5.5,0,0,1,7.045,3.3c2.544,7.03,4,16.607,4.776,23.4.718,6.293,1.275,14.263.8,16.89-.2,1.137-.688,2.814-3.849,8.36l-.088.146A9.149,9.149,0,0,1,449.8,1943.146Zm-4.033-35.582a4.845,4.845,0,0,0-4.294,7.07c2.771,5.369.118,17.4,0,17.911a8.466,8.466,0,0,0,6.833,9.818,8.488,8.488,0,0,0,9.352-5.162l.073-.182.06-.006c3.035-5.339,3.5-6.934,3.691-8.008.462-2.562-.094-10.453-.807-16.7-.77-6.762-2.218-16.286-4.741-23.257a4.852,4.852,0,0,0-6.214-2.911h0a4.853,4.853,0,0,0-2.911,6.213,79.029,79.029,0,0,1,3.475,16.973l.144,1.231-.729-1A4.869,4.869,0,0,0,445.77,1907.564Z",
    transform: "translate(-440.284 -1885.195)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    transform: "translate(2.98 21.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M455,1934.646a26.719,26.719,0,0,0-2.925-12.719,5.176,5.176,0,0,0-6.974-2.226",
    transform: "translate(-444.952 -1918.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M455.245,1934.473l-.649-.007a26.426,26.426,0,0,0-2.889-12.566,4.852,4.852,0,0,0-6.537-2.086l-.3-.577a5.5,5.5,0,0,1,7.411,2.365A27.061,27.061,0,0,1,455.245,1934.473Z",
    transform: "translate(-444.872 -1918.621)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(257.418 5341.537) rotate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(5.339 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M7.244,6.689c.044-1.256-.1-1.394-1.238-1.2a3.332,3.332,0,0,1-.88-.043c-.42-.038-.5.066-.386.454a1.989,1.989,0,0,1-.778,2.31c-.242.185-.447.439-.8.406a2.667,2.667,0,0,1-1.638-.633A5.625,5.625,0,0,1,.406,6.428,3.024,3.024,0,0,1,0,4.911,7.294,7.294,0,0,1,.6,2.3,6.39,6.39,0,0,1,1.761.5.767.767,0,0,1,2.415.2C2.6.225,2.83.152,2.922.41a.589.589,0,0,1-.11.627A5.568,5.568,0,0,0,1.53,3.472a3.338,3.338,0,0,0,.4,2.913,3.624,3.624,0,0,0,.753.71c.286.232.708-.062.781-.508A.908.908,0,0,0,2.947,5.5c-.316-.18-.413-.554-.717-.735-.019-.011-.008-.092.006-.135.139-.427.485-.872,1.092-.669a3.02,3.02,0,0,0,1.323.09,6.326,6.326,0,0,1,2.067.131.439.439,0,0,0,.528-.359,5.607,5.607,0,0,1,.727-2.35c.188-.278.064-.606.036-.908s.062-.5.392-.551c.461-.07.788.051.84.38.039.243.126.279.341.241A1.484,1.484,0,0,1,11.253,2.2c-.013.348.073.705.061,1.065A4.437,4.437,0,0,1,10.6,5.566c-.258.4-.231.568.145,1.057.143.187.312.354.447.546.1.146.224.087.331.052a2.781,2.781,0,0,0,1.31-1.83.48.48,0,0,0-.044-.251c-.291-.443.187-.509.57-.682a.443.443,0,0,0,.249-.471A3.588,3.588,0,0,1,13.679,2.7a.9.9,0,0,0-.121-.666c-.262-.5-.171-.684.353-.861a7.934,7.934,0,0,1,3.528-.39.42.42,0,0,1,.332.226c.12.252-.108.431-.322.593a7.516,7.516,0,0,1-2.081.884.372.372,0,0,0-.276.306,4.356,4.356,0,0,0,.033,1.625c.08.4.5.255.782.288.107.012.22-.038.33-.037.162,0,.345.013.39.209s.149.376-.048.554c-.238.214-.393.518-.7.654-.191.084-.165.251-.111.38a4.7,4.7,0,0,0,.974,1.293c.128.141.355.079.535.121.332.078.439.234.29.53-.428.85-.9.978-1.582.432A4.821,4.821,0,0,1,14.37,6.589a.422.422,0,0,0-.248-.3c-.149-.045-.194.113-.273.205a11.244,11.244,0,0,1-1.38,1.651,6.345,6.345,0,0,1-.724.452.645.645,0,0,1-.637,0,2.2,2.2,0,0,1-1.2-1.188A2.513,2.513,0,0,0,9.331,6.7c-.149-.164-.354-.051-.437.153a6.427,6.427,0,0,0-.249.74,1.03,1.03,0,0,1-.257.446c-.248.264-.331.231-.595-.028A1.423,1.423,0,0,1,7.244,6.689Zm2.951-3.973a.428.428,0,0,0,.007-.1c-.006-.123-.01-.189-.013-.254-.01-.279-.067-.534-.412-.551-.289-.015-.5.228-.556.576-.039.233.093.457,0,.695a4.179,4.179,0,0,0-.119,1.1.567.567,0,0,0,.4.569c.206.068.237-.2.321-.339A4.589,4.589,0,0,0,10.194,2.716Z",
    transform: "translate(0 0.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M4.136,5.5a3.729,3.729,0,0,1-1.57-.074.359.359,0,0,0-.47.245A3.759,3.759,0,0,0,1.8,7.108a1.316,1.316,0,0,1-.682,1.227.435.435,0,0,1-.635-.167,4.89,4.89,0,0,0-.4-.687.7.7,0,0,1,.024-.715,8.706,8.706,0,0,0,.363-1.61A11.357,11.357,0,0,1,.77,3.686a19.662,19.662,0,0,0,.6-2.177A10.055,10.055,0,0,1,1.977.166c.1-.253.429-.165.638-.067a1.11,1.11,0,0,0,.86.076.361.361,0,0,1,.346.079,2.32,2.32,0,0,1,.94,1.281c.116.512.394.987.52,1.5A13.048,13.048,0,0,1,5.77,4.85a11.3,11.3,0,0,1,.02,2.426,1,1,0,0,1-.62.772c-.191.108-.361-.047-.5-.165a.59.59,0,0,1-.234-.661A4.865,4.865,0,0,0,4.6,5.97C4.637,5.584,4.528,5.478,4.136,5.5Zm-.4-1.2c.77.017.683-.135.324-.86a.475.475,0,0,1-.045-.216A2.75,2.75,0,0,0,3.668,2c-.1-.207-.218-.236-.364,0-.267.434-.362.936-.594,1.384-.185.355,0,.663.434.812C3.335,4.262,3.531,4.38,3.731,4.3Z",
    transform: "translate(17.992 0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M1.068,1.7C.94,1.683.644,1.819.529,1.6.353,1.25.029.973,0,.559A.349.349,0,0,1,.337.149,3.218,3.218,0,0,1,.671.116a3.229,3.229,0,0,0,1.24-.1A.476.476,0,0,1,2.2.032,33.828,33.828,0,0,1,5.546.966a3.688,3.688,0,0,1,.359.185.406.406,0,0,1,.223.467.43.43,0,0,1-.36.33,2.911,2.911,0,0,1-1.251.038c-.366-.055-.736-.091-1.1-.135-.167-.02-.195.041-.186.214.036.7.271,1.378.251,2.1A19.4,19.4,0,0,0,3.6,6.525c.036.373.017.754.08,1.133a1.042,1.042,0,0,1-.59.881C3,8.57,2.9,8.58,2.849,8.508c-.269-.36-.629-.659-.638-1.177-.021-1.175-.055-2.35-.123-3.522-.035-.6-.209-1.193-.219-1.8a.288.288,0,0,0-.34-.306C1.4,1.708,1.28,1.7,1.068,1.7Z",
    transform: "translate(24.767 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    transform: "translate(0 15.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M6.057,2.029c.031-.371-.015-.742.035-1.115.071-.529.162-.625.7-.606.556.02.742.232.776.758.04.611-.093,1.207-.081,1.818a5.27,5.27,0,0,0,.436,2.032c.162.373.41.382.753.164a2.255,2.255,0,0,0,.863-1.257,3.991,3.991,0,0,1,.342-.78,3.784,3.784,0,0,0,.4-1.607c.1-.7.171-.81.843-.691.311.055.42-.006.474-.312.059-.328.342-.4.632-.4.522-.01,1.024.18,1.548.158.085,0,.2.049.252.009.539-.436,1.006-.03,1.495.114a.174.174,0,0,1,.065.035c.183.164.526.115.607.38s-.225.38-.324.585a2.3,2.3,0,0,0-.086,1.355,24.959,24.959,0,0,1,.155,2.854,4.54,4.54,0,0,1-.033.962.635.635,0,0,1-.5.533c-.274.076-.426-.082-.556-.271a1.926,1.926,0,0,1-.328-1.255c.039-.738-.011-1.481-.044-2.221-.02-.443-.091-.884-.115-1.328-.013-.246-.106-.316-.345-.294A8.569,8.569,0,0,1,12.536,1.6a.916.916,0,0,1-.45-.16c-.077-.052-.138-.176-.251-.109s-.089.192-.1.3a8.812,8.812,0,0,0-.007,1.669c.086.863.024,1.73.119,2.591a.962.962,0,0,0,.323.678c.322.278.293.451-.067.7-.258.176-.5.364-.849.205a.6.6,0,0,1-.251-.2A3.484,3.484,0,0,1,10.432,5.4c-.008-.1.043-.226-.07-.268-.13-.049-.2.078-.254.168a4.074,4.074,0,0,1-1.3,1.351.934.934,0,0,1-1.043-.011,2.257,2.257,0,0,1-.842-.834c-.158-.262-.3-.257-.448.024-.222.414-.469.814-.7,1.222-.286.5-.558.572-1.112.431A3.866,3.866,0,0,0,2.876,7.33,1.768,1.768,0,0,1,.655,6.051a.292.292,0,0,0-.054-.1c-.419-.431-.28-.99-.36-1.5C.058,3.274.2,2.08.02.9-.079.237.189.015.746.148a.307.307,0,0,0,.111,0c.541-.08.9.147.773.894a5.611,5.611,0,0,0,.006,1.111,24.754,24.754,0,0,0,.178,2.887.957.957,0,0,0,.885.689,6.985,6.985,0,0,1,2.06-.04.254.254,0,0,0,.3-.1c.243-.463.676-.842.642-1.431A.432.432,0,0,1,5.737,3.9,3.136,3.136,0,0,0,6.057,2.029Z",
    transform: "translate(9.151 1.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M7.335,1.426c-.213.522.106.619.5.825a1.906,1.906,0,0,1,1,1.121,6.168,6.168,0,0,1,.359,1.419,4.157,4.157,0,0,1-.3,1.752,4.253,4.253,0,0,1-.957,1.517,1.618,1.618,0,0,1-2.448-.007A2.7,2.7,0,0,1,4.7,6.668c-.012-.144-.107-.366-.341-.115a3.174,3.174,0,0,1-2.38.947c-.3.007-.589.082-.884.1-.352.024-.667-.036-.808-.424a.517.517,0,0,0-.1-.154c-.332-.381-.209-.748.289-.849a5.507,5.507,0,0,1,1.648-.156,1.419,1.419,0,0,0,1-.434.325.325,0,0,0,.005-.522,7.155,7.155,0,0,0-1.151-.973c-.265-.145-.42-.456-.674-.574C.726,3.249.731,2.723.665,2.247a1.736,1.736,0,0,1,1-1.438A1.061,1.061,0,0,0,1.98.616,2.579,2.579,0,0,1,4.163.029a.614.614,0,0,1,.6.641.79.79,0,0,1-.586.795.368.368,0,0,1-.18-.007A1.813,1.813,0,0,0,2.157,2.1a.3.3,0,0,0,.066.43,8.5,8.5,0,0,0,1.2.928,2.86,2.86,0,0,1,.541.556c.113.121.232.248.412.2s.194-.231.2-.368a4.834,4.834,0,0,1,1.481-3c.277-.312.586-.117.861-.036S7.451,1.057,7.335,1.426ZM5.906,4.863a4.472,4.472,0,0,0,.172,1.506c.061.3.209.633.54.695s.559-.212.711-.452A3.122,3.122,0,0,0,7.7,4.03a.649.649,0,0,0-.8-.568c-.13.02-.2-.089-.282-.153-.35-.259-.48-.22-.571.2A4.7,4.7,0,0,0,5.906,4.863Z",
    transform: "translate(0 0.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M2.066,2.593c.182-.295.412-.421.527-.671a.835.835,0,0,1,.99-.374A1.758,1.758,0,0,1,4.9,2.711a10.676,10.676,0,0,1,.552,1.671,8.112,8.112,0,0,0,.49,1.391c.03.089.035.22.157.227s.147-.114.18-.207a15.24,15.24,0,0,0,.938-3.881.8.8,0,0,1,.327-.673c.232-.134.449.039.684.128.506.19.418.543.34.9C8.37,3.185,8.1,4.089,7.9,5c-.165.755-.481,1.455-.633,2.209a1.826,1.826,0,0,1-.678,1c-.271.225-.944-.078-1.05-.462a11.583,11.583,0,0,0-.681-1.584c-.185-.415-.29-.865-.443-1.295-.206-.579-.433-1.152-.635-1.732-.089-.255-.229-.19-.361-.075a2.346,2.346,0,0,0-.574.9c-.293.7-.517,1.431-.822,2.126a4.906,4.906,0,0,0-.39,1.35.853.853,0,0,1-.419.7c-.48.279-.6.244-.831-.264a.678.678,0,0,0-.165-.242.642.642,0,0,1-.2-.679C.274,5.787.31,4.6.467,3.422c.054-.405.112-.811.177-1.214A7.809,7.809,0,0,0,.734.5C.71.081,1.039-.117,1.421.072c.544.27.694.587.649,1.28C2.046,1.731,2.066,2.114,2.066,2.593Z",
    transform: "translate(35.413 1.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M2.672,1.5a2.578,2.578,0,0,1,1.4.62,1.173,1.173,0,0,1,.328.761c.033.481.052.965.041,1.447-.01.425-.27.8-.317,1.218A4.166,4.166,0,0,1,3.6,6.806a1.663,1.663,0,0,1-2.174.85.636.636,0,0,1-.26-.2A4.08,4.08,0,0,1,.1,3.767a5.154,5.154,0,0,1,.927-2.509c.232-.262.312-.7.688-.847.414-.158.767-.578,1.3-.339.185.084.487.066.47.329-.02.319-.062.682-.442.833C2.9,1.287,2.753,1.317,2.672,1.5ZM3.13,3.7a1.3,1.3,0,0,0-.5-1.371C2.52,2.239,2.526,2.114,2.49,2c-.027-.088.02-.229-.108-.249s-.167.114-.226.208a5.128,5.128,0,0,0-.666,3.455,1.349,1.349,0,0,0,.211.545c.134.208.29.3.534.062A3.059,3.059,0,0,0,3.13,3.7Z",
    transform: "translate(30.577 1.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M1.083,0c.469,0,.673.241.6.689a2.233,2.233,0,0,1-.213.79c-.108.194,0,.547.014.83a27.337,27.337,0,0,1,0,3.508A16.143,16.143,0,0,0,1.5,7.63a1.549,1.549,0,0,1-.419.928.3.3,0,0,1-.509,0A2.054,2.054,0,0,1,0,7.018C.1,5.564.122,4.105.151,2.648a3.229,3.229,0,0,1-.016-.883c.014-.047,0-.121.026-.143.329-.265.19-.61.191-.944C.354.181.573,0,1.083,0Z",
    transform: "translate(27.818 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XX",
    transform: "translate(-12 880.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(149.442 4104.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M237.088,1215.427a.324.324,0,0,1-.325-.325v-74.316a.325.325,0,1,1,.65,0V1215.1A.324.324,0,0,1,237.088,1215.427Z",
    transform: "translate(-236.763 -1140.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(189.726 4293.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    transform: "translate(0 0)",
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(153.592 4131.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M243.477,1184.768a.325.325,0,0,1-.133-.621l4.6-2.063a.325.325,0,0,1,.266.593l-4.6,2.063A.331.331,0,0,1,243.477,1184.768Z",
    transform: "translate(-243.152 -1182.056)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270",
    transform: "translate(-11.652 4072.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(0 12.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(27.45 6.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(0 11.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(2.186 73.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 168.758,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M200.087,1265.64H31.321a.323.323,0,0,1-.321-.325V1253.49a.323.323,0,0,1,.321-.325H200.087a.323.323,0,0,1,.321.325v11.825A.323.323,0,0,1,200.087,1265.64Zm-168.445-.65H199.766v-11.176H31.641Z",
    transform: "translate(-31 -1253.165)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(12.01 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M52.02,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,52.02,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,52.02,1259.061Z",
    transform: "translate(-49.491 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(2.095 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(19.007 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M62.793,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,62.793,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,62.793,1259.061Z",
    transform: "translate(-60.264 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(1.04 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M64.518,1262.454H62.19a.325.325,0,0,1,0-.65h2.328a.325.325,0,0,1,0,.65Z",
    transform: "translate(-61.865 -1261.805)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(26.003 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M73.565,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,73.565,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,73.565,1259.061Z",
    transform: "translate(-71.036 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(0.91 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(1.294)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M74.755,1263.051a.325.325,0,0,1-.325-.325v-2.59a.325.325,0,0,1,.649,0v2.59A.324.324,0,0,1,74.755,1263.051Z",
    transform: "translate(-74.43 -1259.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x1: 2.59,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M75.351,1262.454h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,0,1,0,.65Z",
    transform: "translate(-72.437 -1261.805)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(2.186 84.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M31.533,1360.615a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,1,1,.65,0v88.594A.325.325,0,0,1,31.533,1360.615Z",
    transform: "translate(-31.208 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    transform: "translate(170.943 84.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M294.516,1306.908a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,1,1,.65,0v34.887A.325.325,0,0,1,294.516,1306.908Z",
    transform: "translate(-294.191 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(170.943 102.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M322.244,1305.874a.3.3,0,0,1-.264-.325v-6.671H294.455a.332.332,0,0,1,0-.65h27.789a.3.3,0,0,1,.264.325v7A.3.3,0,0,1,322.244,1305.874Z",
    transform: "translate(-294.191 -1298.229)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(13.53 101.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M68.208,1329.829a16.377,16.377,0,1,1,16.377-16.376A16.4,16.4,0,0,1,68.208,1329.829Zm0-32.1a15.727,15.727,0,1,0,15.728,15.728A15.745,15.745,0,0,0,68.208,1297.724Z",
    transform: "translate(-51.831 -1297.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(29.796 117.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M135.844,1352.3H77.2a.325.325,0,0,1-.325-.325v-29.536a.325.325,0,0,1,.325-.325h58.644a.325.325,0,0,1,.325.325v29.536A.325.325,0,0,1,135.844,1352.3Zm-58.319-.649h57.995v-28.887H77.525Z",
    transform: "translate(-76.875 -1322.119)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(97.001 122.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M231.858,1329.359H180.672a.325.325,0,0,1,0-.65h51.187a.325.325,0,0,1,0,.65Z",
    transform: "translate(-180.347 -1328.709)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M231.858,1341.551H180.672a.325.325,0,1,1,0-.649h51.187a.325.325,0,1,1,0,.649Z",
    transform: "translate(-180.347 -1340.902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    transform: "translate(0 15.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M209.566,1353.745H180.672a.325.325,0,0,1,0-.65h28.894a.325.325,0,0,1,0,.65Z",
    transform: "translate(-180.347 -1353.095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(145.087 149.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M256.586,1375.912a2.205,2.205,0,1,1,2.206-2.206A2.208,2.208,0,0,1,256.586,1375.912Zm0-3.761a1.556,1.556,0,1,0,1.556,1.555A1.558,1.558,0,0,0,256.586,1372.151Z",
    transform: "translate(-254.381 -1371.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(6.184 0.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 1.881,
    cy: 1.881,
    r: 1.881
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(12.043 0.469)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 1.881,
    cy: 1.881,
    r: 1.881
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(169.811 92.048)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    transform: "translate(40.134 33.041)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    transform: "translate(40.133 71.464)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(204.118 144.88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(41.721 35.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 0.65,
    height: 38.344
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144",
    transform: "translate(98.129 160.335)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 76.846,
    height: 56.262,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M259.254,1444.37H182.408a.325.325,0,0,1-.325-.325v-56.262a.325.325,0,0,1,.325-.325h76.846a.325.325,0,0,1,.325.325v56.262A.325.325,0,0,1,259.254,1444.37Zm-76.521-.649h76.2v-55.613h-76.2Z",
    transform: "translate(-182.083 -1387.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(173.928 189.478)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(221.957 221.04)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(207.11 93.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M362.029,1337.576H349.874v-.65h12.155a2.1,2.1,0,0,0,2.1-2.1v-47.943a2.1,2.1,0,0,0-2.1-2.1h-6.754v-.65h6.754a2.754,2.754,0,0,1,2.751,2.751v47.943A2.754,2.754,0,0,1,362.029,1337.576Z",
    transform: "translate(-349.874 -1284.132)",
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(172.802 93.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 31.213,
    height: 0.65,
    transform: "translate(0 0.122) rotate(-0.224)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(177.114 190.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M350.557,1466.506H319.247a2.386,2.386,0,0,1-2.383-2.384v-27.211a1.736,1.736,0,0,0-1.734-1.734H303.692v-.65H315.13a2.386,2.386,0,0,1,2.383,2.383v27.211a1.736,1.736,0,0,0,1.734,1.734h31.311Z",
    transform: "translate(-303.692 -1434.528)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(71.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 29.503,
    height: 24.701
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(221.613 119.511)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 41.511,
    height: 0.65,
    fill: "#0067ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(133.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 189.644,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M426.732,1134.73H237.088a.324.324,0,0,1-.325-.325V1122.58a.325.325,0,0,1,.325-.325H426.732a.325.325,0,0,1,.325.325v11.825A.325.325,0,0,1,426.732,1134.73Zm-189.319-.649H426.407V1122.9H237.413Z",
    transform: "translate(-236.763 -1122.255)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(3.431 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M244.574,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,244.574,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,244.574,1128.15Z",
    transform: "translate(-242.045 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(2.096 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(10.428 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M255.347,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,255.347,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,255.347,1128.15Z",
    transform: "translate(-252.818 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(1.041 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M257.073,1131.544h-2.328a.325.325,0,0,1,0-.65h2.328a.325.325,0,1,1,0,.65Z",
    transform: "translate(-254.42 -1130.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(17.425 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M266.12,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,266.12,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,266.12,1128.15Z",
    transform: "translate(-263.591 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(0.909 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M267.31,1132.141a.324.324,0,0,1-.325-.325v-2.59a.325.325,0,1,1,.65,0v2.59A.325.325,0,0,1,267.31,1132.141Z",
    transform: "translate(-266.985 -1128.901)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x1: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M267.906,1131.544h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,1,1,0,.65Z",
    transform: "translate(-264.991 -1130.895)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(323.287 11.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M529.071,1176a.324.324,0,0,1-.325-.325v-34.887a.325.325,0,1,1,.649,0v34.887A.325.325,0,0,1,529.071,1176Z",
    transform: "translate(-528.746 -1140.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    transform: "translate(205.164 49.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M423.086,1198.45H347.2a.325.325,0,0,1,0-.65h75.883a.325.325,0,0,1,0,.65Z",
    transform: "translate(-346.879 -1197.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M423.086,1210.642H347.2a.325.325,0,0,1,0-.65h75.883a.325.325,0,0,1,0,.65Z",
    transform: "translate(-346.879 -1209.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(0 15.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M390.038,1222.834H347.2a.325.325,0,1,1,0-.65h42.835a.325.325,0,0,1,0,.65Z",
    transform: "translate(-346.879 -1222.185)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(263.142 38.799)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 89.882,
    height: 115.955,
    transform: "translate(0.325 0.324)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M526.352,1298.6H436.469a.325.325,0,0,1-.325-.325V1182.317a.324.324,0,0,1,.325-.325h89.883a.324.324,0,0,1,.325.325v115.955A.325.325,0,0,1,526.352,1298.6Zm-89.558-.649h89.233V1182.641H436.794Z",
    transform: "translate(-436.144 -1181.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(141.681 20.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(36.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M316,1176.183a11.016,11.016,0,1,1,11.016-11.016A11.029,11.029,0,0,1,316,1176.183Zm0-21.382a10.366,10.366,0,1,0,10.366,10.366A10.378,10.378,0,0,0,316,1154.8Z",
    transform: "translate(-304.979 -1154.151)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(9.309 10.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M301.16,1216.89H263.8a.325.325,0,0,1-.325-.325v-46.158a.324.324,0,0,1,.325-.325H301.16a.324.324,0,0,1,.325.325v46.158A.325.325,0,0,1,301.16,1216.89Zm-37.039-.649h36.714v-45.509H264.121Z",
    transform: "translate(-263.471 -1170.082)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(0 25.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M260.125,1224.964a17.522,17.522,0,0,1-10.864-3.789.325.325,0,0,1-.052-.457l5.206-6.547a.325.325,0,0,1,.456-.053,8.361,8.361,0,0,0,5.254,1.831,8.454,8.454,0,0,0,4.723-15.464.325.325,0,0,1-.088-.451l4.682-6.932a.326.326,0,0,1,.451-.088,17.469,17.469,0,0,1-9.769,31.949Zm-10.2-4.1a16.819,16.819,0,1,0,19.877-27.128l-4.32,6.4a9.1,9.1,0,0,1-5.353,16.466,9,9,0,0,1-5.4-1.774Z",
    transform: "translate(-249.138 -1192.96)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(271.904 48.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(35.179 36.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M514.813,1274.5a11.016,11.016,0,1,1,11.016-11.015A11.028,11.028,0,0,1,514.813,1274.5Zm0-21.382a10.366,10.366,0,1,0,10.366,10.367A10.379,10.379,0,0,0,514.813,1253.115Z",
    transform: "translate(-503.797 -1252.465)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(0.056 9.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M496.2,1248.97H450.045a.325.325,0,0,1-.325-.325v-37.364a.325.325,0,0,1,.325-.325H496.2a.325.325,0,0,1,.325.325v37.364A.325.325,0,0,1,496.2,1248.97Zm-45.834-.65h45.509v-36.714H450.369Z",
    transform: "translate(-449.72 -1210.957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M467.1,1225.078a17.468,17.468,0,0,1-13.679-28.331.325.325,0,0,1,.457-.053l6.548,5.206a.324.324,0,0,1,.053.456,8.361,8.361,0,0,0-1.831,5.255,8.454,8.454,0,0,0,15.465,4.723.325.325,0,0,1,.451-.088l6.932,4.682a.326.326,0,0,1,.088.451A17.458,17.458,0,0,1,467.1,1225.078Zm-13.369-27.671a16.819,16.819,0,1,0,27.128,19.877l-6.4-4.32A9.1,9.1,0,0,1,458,1207.611a8.994,8.994,0,0,1,1.774-5.4Z",
    transform: "translate(-449.634 -1196.624)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(223.347 173.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M436.777,1474.457h-61.27a.325.325,0,0,1-.325-.325v-39.187a.325.325,0,0,1,.65,0v38.862h60.621v-83.058H375.2a.325.325,0,1,1,0-.649h61.578a.324.324,0,0,1,.325.325v83.707A.325.325,0,0,1,436.777,1474.457Z",
    transform: "translate(-374.874 -1390.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(271.929 116.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M510.852,1302.567H450a.325.325,0,0,1,0-.65h60.855a.325.325,0,1,1,0,.65Z",
    transform: "translate(-449.672 -1301.918)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M510.852,1314.76H450a.325.325,0,0,1,0-.65h60.855a.325.325,0,1,1,0,.65Z",
    transform: "translate(-449.672 -1314.111)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(0 15.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M484.348,1326.953H450a.325.325,0,0,1,0-.65h34.352a.325.325,0,0,1,0,.65Z",
    transform: "translate(-449.672 -1326.304)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(37.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(2.101 184.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(3.985 0.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M58.48,1379.364l-.233,14.535.759-.1c-.575-2.838-1.048-5.687-1.348-8.569-.174-1.672-1.352-6.1.4-6.958.48-.236,3.16.333,3.715.383q1.86.167,3.724.287c2.486.162,4.976.263,7.467.321,9.993.23,19.983-.293,29.958-.813l-.1-.759a275.429,275.429,0,0,1-46.846,2.545c-.5-.015-.5.758,0,.774a276.558,276.558,0,0,0,47.052-2.573c.431-.061.329-.782-.1-.76-15.365.8-30.78,1.537-46.1-.329a.389.389,0,0,0-.386.387A92.231,92.231,0,0,0,58.261,1394c.089.437.753.323.76-.1l.233-14.535a.387.387,0,0,0-.774,0Z",
    transform: "translate(-55.601 -1377.343)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M99.131,1377.785,99,1393.408h.774q-1-8.389-1.217-16.829l-.72.195,3.978,8.33c.595,1.246,4.2,6.918,3.253,8.025-1.01,1.175-7.552.009-8.783-.06l-9.03-.5L49.84,1390.5v.774l50.607-.8v-.773l-34.858,2.172c-.494.031-.5.8,0,.773l34.858-2.172c.492-.031.5-.781,0-.773l-50.607.8a.387.387,0,0,0,0,.774l29.67,1.639,14.19.784c4.081.225,8.522,1.014,12.526-.088a.392.392,0,0,0,.231-.568l-7.956-16.66a.39.39,0,0,0-.721.2q.213,8.447,1.217,16.829c.058.481.769.512.774,0l.135-15.624a.387.387,0,0,0-.774,0Z",
    transform: "translate(-49.466 -1376.194)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(6.592 19.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M59.99,1406.844h48.7a.387.387,0,0,0,0-.773H59.99a.387.387,0,0,0,0,.773Z",
    transform: "translate(-59.616 -1406.071)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(11.4 17.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M67.392,1403.316l39.305.708a.387.387,0,0,0,0-.774l-39.305-.708a.387.387,0,0,0,0,.773Z",
    transform: "translate(-67.019 -1402.543)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(51.023 1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M128.112,1378.745q.141,6.462-.09,12.919c-.018.5.756.5.774,0q.23-6.459.09-12.919a.387.387,0,0,0-.774,0Z",
    transform: "translate(-128.023 -1378.371)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(52.19 2.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M129.873,1380.251q-.16,7.147.156,14.287c.022.5.795.5.774,0q-.316-7.142-.156-14.287a.387.387,0,0,0-.774,0Z",
    transform: "translate(-129.819 -1379.878)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(24.609 6.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M90.3,1388.254a4.126,4.126,0,0,0-.255,1.2q-.036.617-.065,1.234-.015.181-.24.181a.35.35,0,0,1-.123-.021.482.482,0,0,1-.312-.486,2.427,2.427,0,0,1,.029-.309,2.415,2.415,0,0,0,.029-.3q.029-.21.072-.631a3.3,3.3,0,0,1-1.132.7.547.547,0,0,1-.175.029.787.787,0,0,1-.617-.378.838.838,0,0,1-.159-.523,2.08,2.08,0,0,1,.123-.646,7.984,7.984,0,0,1,1.227-2.3q.421-.558.748-.559c.194,0,.3.072.327.218a.228.228,0,0,1-.123.261c-.17.092-.259.143-.269.153a7.2,7.2,0,0,0-1.118,1.742,2.83,2.83,0,0,0-.312,1.183c0,.063,0,.127.007.189a.181.181,0,0,1,.044.07c.019.041.045.054.079.04a6.356,6.356,0,0,0,1.445-.995.845.845,0,0,0,.167-.334.265.265,0,0,1,.261-.2c-.039,0,0,0,.116-.014.058-.01.1,0,.116.029a.65.65,0,0,1,.138.334A.378.378,0,0,1,90.3,1388.254Z",
    transform: "translate(-87.355 -1385.445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(3.375 1.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M95.071,1389.125a1.8,1.8,0,0,1-1.212,1.147.853.853,0,0,1-.189.022,1.18,1.18,0,0,1-.835-.45,1.115,1.115,0,0,1-.283-.791,2.536,2.536,0,0,1,.319-1.155,1.76,1.76,0,0,1,.335-.449.634.634,0,0,1,.428-.225.33.33,0,0,1,.218.087,2.051,2.051,0,0,0,.545.233.819.819,0,0,1,.494.392,1.877,1.877,0,0,1,.254.835A.85.85,0,0,1,95.071,1389.125Zm-.581-.451q-.051-.53-.283-.631a.175.175,0,0,0-.065-.014c-.058,0-.131.048-.218.145a.693.693,0,0,1-.225.2c-.034.014-.082,0-.145-.044a.331.331,0,0,0-.123-.065.05.05,0,0,0-.036.015.84.84,0,0,0-.254.675.93.93,0,0,0,.145.53c.135.2.249.3.341.3a.81.81,0,0,0,.617-.4A1,1,0,0,0,94.49,1388.674Z",
    transform: "translate(-92.552 -1387.222)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(6.385 0.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M97.908,1390.254a.354.354,0,0,1-.029.2c-.029.066-.064.1-.105.1a.138.138,0,0,0-.091.032.061.061,0,0,1-.058.022q-.385-.145-.436-.378-.021-.1.138-.207a.44.44,0,0,1,.225-.1.464.464,0,0,1,.229.1A.315.315,0,0,1,97.908,1390.254Zm.7-4.428a14.046,14.046,0,0,1-.37,1.83,7.275,7.275,0,0,0-.261,1.88.15.15,0,0,1-.076.12.177.177,0,0,1-.142.04q-.37-.073-.392-.363c-.005-.1-.007-.2-.007-.305a7.993,7.993,0,0,1,.218-1.669q.333-1.459.363-1.656a.155.155,0,0,1,.108-.123.263.263,0,0,1,.182-.007l.247.073A.178.178,0,0,1,98.612,1385.826Z",
    transform: "translate(-97.186 -1385.559)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(190.805 92.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    transform: "translate(3.984 0.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M349.016,1237.589l-.233,14.536.76-.1c-.575-2.838-1.048-5.687-1.348-8.569-.174-1.672-1.352-6.1.4-6.958.48-.236,3.16.333,3.716.383q1.859.167,3.723.287c2.486.162,4.976.263,7.467.321,9.993.23,19.983-.293,29.958-.813l-.1-.76a275.338,275.338,0,0,1-46.846,2.545c-.5-.016-.5.758,0,.774a276.655,276.655,0,0,0,47.052-2.573c.431-.061.329-.783-.1-.76-15.365.8-30.78,1.537-46.1-.329a.39.39,0,0,0-.387.387,92.165,92.165,0,0,0,1.825,16.27c.088.436.752.323.759-.1l.233-14.536a.387.387,0,0,0-.773,0Z",
    transform: "translate(-346.137 -1235.569)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M389.667,1236.01l-.135,15.624h.774q-1-8.389-1.216-16.829l-.72.195,3.978,8.33c.6,1.246,4.2,6.918,3.253,8.025-1.011,1.174-7.552.008-8.784-.06l-9.03-.5-37.41-2.067v.773l50.607-.8v-.774l-34.858,2.172c-.494.031-.5.8,0,.774l34.858-2.172a.387.387,0,0,0,0-.774l-50.607.8a.387.387,0,0,0,0,.773l29.67,1.64,14.19.784c4.081.225,8.521,1.013,12.525-.088a.392.392,0,0,0,.231-.568l-7.956-16.66a.389.389,0,0,0-.72.2q.212,8.446,1.216,16.829c.058.481.769.511.774,0l.135-15.624a.387.387,0,0,0-.774,0Z",
    transform: "translate(-340.003 -1234.42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(6.592 19.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M350.525,1265.07h48.7a.387.387,0,0,0,0-.774h-48.7a.387.387,0,0,0,0,.774Z",
    transform: "translate(-350.152 -1264.296)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(11.4 17.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M357.928,1261.542l39.305.708a.387.387,0,0,0,0-.774l-39.305-.708a.387.387,0,0,0,0,.774Z",
    transform: "translate(-357.555 -1260.769)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(51.022 1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M418.648,1236.97q.141,6.461-.09,12.919c-.017.5.756.5.774,0q.231-6.459.09-12.919a.387.387,0,0,0-.774,0Z",
    transform: "translate(-418.559 -1236.597)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(52.19 2.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M420.41,1238.477q-.161,7.148.155,14.288c.022.5.8.5.774,0q-.316-7.142-.156-14.288a.387.387,0,0,0-.773,0Z",
    transform: "translate(-420.356 -1238.103)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225",
    transform: "translate(24.609 6.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M380.838,1246.48a4.141,4.141,0,0,0-.255,1.2q-.036.618-.065,1.235-.015.181-.24.181a.355.355,0,0,1-.123-.022.483.483,0,0,1-.312-.486,2.4,2.4,0,0,1,.029-.309,2.425,2.425,0,0,0,.029-.3q.029-.21.073-.632a3.283,3.283,0,0,1-1.133.7.546.546,0,0,1-.174.029.787.787,0,0,1-.618-.377.843.843,0,0,1-.159-.523,2.088,2.088,0,0,1,.123-.646,7.989,7.989,0,0,1,1.227-2.3q.421-.559.748-.559.29,0,.327.218a.227.227,0,0,1-.123.261q-.254.139-.269.153a7.248,7.248,0,0,0-1.118,1.742,2.828,2.828,0,0,0-.312,1.183c0,.063,0,.126.007.189a.185.185,0,0,1,.044.069c.019.042.045.055.08.04a6.349,6.349,0,0,0,1.444-1,.838.838,0,0,0,.167-.334.266.266,0,0,1,.262-.2c-.039,0,0,0,.116-.014.058-.01.1,0,.116.029a.647.647,0,0,1,.138.334A.366.366,0,0,1,380.838,1246.48Z",
    transform: "translate(-377.891 -1243.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223",
    transform: "translate(3.375 1.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M385.607,1247.35a1.8,1.8,0,0,1-1.213,1.147.811.811,0,0,1-.188.022,1.181,1.181,0,0,1-.835-.45,1.119,1.119,0,0,1-.283-.792,2.528,2.528,0,0,1,.32-1.154,1.763,1.763,0,0,1,.334-.45.633.633,0,0,1,.429-.225.326.326,0,0,1,.218.087,2.027,2.027,0,0,0,.544.232.822.822,0,0,1,.494.392,1.877,1.877,0,0,1,.255.835A.854.854,0,0,1,385.607,1247.35Zm-.581-.45q-.052-.53-.284-.631a.175.175,0,0,0-.065-.014q-.087,0-.218.145a.711.711,0,0,1-.225.2c-.034.014-.083,0-.145-.043a.339.339,0,0,0-.123-.066.051.051,0,0,0-.036.014.842.842,0,0,0-.254.676.935.935,0,0,0,.145.53c.136.2.249.3.341.3a.809.809,0,0,0,.617-.4A1.006,1.006,0,0,0,385.027,1246.9Z",
    transform: "translate(-383.088 -1245.448)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(6.386 0.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M388.444,1248.48a.361.361,0,0,1-.029.2c-.029.066-.064.1-.106.1a.131.131,0,0,0-.09.032.061.061,0,0,1-.058.022q-.386-.145-.436-.377-.022-.1.138-.207a.438.438,0,0,1,.225-.1.47.47,0,0,1,.229.1A.316.316,0,0,1,388.444,1248.48Zm.7-4.428a14.2,14.2,0,0,1-.371,1.829,7.311,7.311,0,0,0-.261,1.88.151.151,0,0,1-.076.12.176.176,0,0,1-.142.04q-.369-.072-.392-.363c0-.1-.007-.2-.007-.3a8.006,8.006,0,0,1,.218-1.67q.334-1.458.363-1.655a.156.156,0,0,1,.109-.123.261.261,0,0,1,.181-.007l.247.072A.18.18,0,0,1,389.149,1244.052Z",
    transform: "translate(-387.723 -1243.785)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    transform: "translate(50.529 141.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(4.376 4.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(1.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M133.137,1318.516a59.484,59.484,0,0,1,5.581,6.566c.291.4.962.012.668-.39a60.891,60.891,0,0,0-5.7-6.722c-.349-.355-.9.192-.547.547Z",
    transform: "translate(-133.025 -1317.854)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    transform: "translate(0 0.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M136.712,1319.043q-3.021,4.269-5.883,8.646c-.273.418.4.806.668.39q2.861-4.378,5.883-8.646c.288-.407-.383-.794-.668-.39Z",
    transform: "translate(-130.765 -1318.873)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M132.266,1314.709c-2.3,2.448-6.042,7.214-3.1,10.539,2.1,2.376,5.937,1.326,8.021-.44,2.657-2.252,4.235-7.252,2.277-10.379-1.687-2.693-5.531-2.562-8.205-1.819-2.99.831-6.216,2.914-7.049,6.079a5.219,5.219,0,0,0,5.586,6.5,11.974,11.974,0,0,0,9.413-7.025,5.657,5.657,0,0,0-4.6-7.861c-5.076-.776-12.233,3.555-9.042,9.259a.347.347,0,0,0,.6-.349c-2.538-4.537,2.382-7.9,6.465-8.275a5.968,5.968,0,0,1,5.525,2.12c1.377,1.923.877,4.3-.277,6.177-1.966,3.2-7.935,7.35-11.559,4.325a4.891,4.891,0,0,1-1.218-5.385,8.038,8.038,0,0,1,3.648-3.765c2.434-1.409,5.919-2.254,8.572-.968,3.4,1.649,2.4,6.509.864,9.109-1.5,2.538-5.049,4.414-7.845,2.775-4.024-2.359.514-8.1,2.415-10.124.305-.324-.183-.815-.49-.489Z",
    transform: "translate(-124.028 -1310.209)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    transform: "translate(54.783 52.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M130.731,1259.2c-.924-18.079,2.313-33.738,9.62-46.545a68.655,68.655,0,0,1,25.125-25.116,93.939,93.939,0,0,1,37.748-12.15l.057.972a92.893,92.893,0,0,0-37.339,12.034,67.681,67.681,0,0,0-24.756,24.762c-7.206,12.638-10.4,28.112-9.481,45.993Z",
    transform: "translate(-130.577 -1175.392)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    transform: "translate(67.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M235.707,1172.551l4.518,2.377v-.592a33.26,33.26,0,0,0-5.758,4.632.343.343,0,0,0,.485.484,32.451,32.451,0,0,1,5.62-4.525.346.346,0,0,0,0-.592l-4.518-2.377c-.39-.205-.737.386-.346.592Z",
    transform: "translate(-234.367 -1171.916)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(133.704 44.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M260.326,1164.949c-2.3,2.448-6.042,7.214-3.1,10.54,2.1,2.376,5.938,1.326,8.021-.44,2.656-2.252,4.235-7.252,2.277-10.379-1.687-2.693-5.531-2.563-8.205-1.819-2.99.831-6.216,2.914-7.049,6.079a5.219,5.219,0,0,0,5.586,6.5,11.975,11.975,0,0,0,9.413-7.025,5.657,5.657,0,0,0-4.6-7.862c-5.076-.776-12.233,3.555-9.042,9.259a.347.347,0,0,0,.6-.349c-2.538-4.537,2.382-7.9,6.464-8.276a5.97,5.97,0,0,1,5.525,2.121c1.378,1.923.877,4.3-.277,6.177-1.966,3.2-7.935,7.35-11.559,4.325a4.891,4.891,0,0,1-1.218-5.385,8.038,8.038,0,0,1,3.648-3.765c2.434-1.409,5.919-2.254,8.572-.968,3.4,1.649,2.4,6.51.864,9.109-1.5,2.537-5.049,4.414-7.845,2.775-4.024-2.359.514-8.1,2.415-10.124.305-.325-.183-.815-.49-.489Z",
    transform: "translate(-252.088 -1160.449)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(149.546 37.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M276.8,1156.7a.325.325,0,0,1-.283-.484l4.068-7.224a.325.325,0,1,1,.566.318l-4.068,7.224A.325.325,0,0,1,276.8,1156.7Z",
    transform: "translate(-276.478 -1148.827)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    transform: "translate(153.053 43.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M282.2,1161.543a.325.325,0,0,1-.149-.614l4.488-2.305a.325.325,0,1,1,.3.577l-4.488,2.306A.328.328,0,0,1,282.2,1161.543Z",
    transform: "translate(-281.878 -1158.588)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269",
    transform: "translate(168.698 60.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M248.795,1191.365a.32.32,0,0,1-.152-.038.325.325,0,0,1-.134-.439l2.814-5.3a.325.325,0,1,1,.574.3l-2.814,5.3A.325.325,0,0,1,248.795,1191.365Z",
    transform: "translate(-248.47 -1185.416)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(156.472 4053.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(-251.078 39.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272",
    transform: "translate(273.582 11.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M436.349,1140.962v119.6H318.227v60.379H282.735V1141.006",
    transform: "translate(-282.41 -1140.637)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M318.051,1321.091H282.56a.324.324,0,0,1-.325-.325V1140.831a.325.325,0,1,1,.65,0v179.61h34.842v-60.054a.325.325,0,0,1,.325-.325h117.8V1140.787a.325.325,0,1,1,.65,0v119.6a.325.325,0,0,1-.325.325h-117.8v60.054A.324.324,0,0,1,318.051,1321.091Z",
    transform: "translate(-282.235 -1140.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(0 44.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(0 115.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    d: "M7.442,0H120.533a7.442,7.442,0,0,1,7.442,7.442V82.913a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.442A7.442,7.442,0,0,1,7.442,0Z",
    transform: "translate(0 30.533) rotate(-13.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M-118.829,1481.654a.322.322,0,0,1-.168-.047.322.322,0,0,1-.147-.2l-18.628-75.825a5.123,5.123,0,0,1,.6-3.9,5.122,5.122,0,0,1,3.181-2.337L-19.1,1371.116a5.164,5.164,0,0,1,6.24,3.778l18.628,75.825a.325.325,0,0,1-.238.393l-124.278,30.532A.318.318,0,0,1-118.829,1481.654Zm100.956-110.039a4.529,4.529,0,0,0-1.076.131l-114.891,28.227a4.514,4.514,0,0,0-3.3,5.455l18.551,75.509L5.056,1450.559l-18.55-75.51A4.519,4.519,0,0,0-17.873,1371.616Z",
    transform: "translate(138.611 -1370.278)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274",
    transform: "translate(8.03 9.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 114.496,
    height: 67.808,
    rx: 2,
    transform: "translate(0.053 27.37) rotate(-13.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M-109.439,1477.457a1.609,1.609,0,0,1-.838-.236,1.61,1.61,0,0,1-.736-1l-15.558-63.327a1.61,1.61,0,0,1,.188-1.228,1.612,1.612,0,0,1,1-.736l108.666-26.7a1.613,1.613,0,0,1,1.228.188,1.611,1.611,0,0,1,.736,1L.807,1448.748a1.625,1.625,0,0,1-1.189,1.964h0l-108.666,26.7A1.612,1.612,0,0,1-109.439,1477.457Zm93.111-92.623a.987.987,0,0,0-.233.028l-108.667,26.7a.969.969,0,0,0-.6.442.971.971,0,0,0-.113.737l15.558,63.327a.977.977,0,0,0,1.179.714l108.666-26.7a.968.968,0,0,0,.6-.442.968.968,0,0,0,.113-.737l-15.558-63.327A.976.976,0,0,0-16.327,1384.834ZM-.459,1450.4h0Z",
    transform: "translate(126.619 -1384.183)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(20.002 96.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M-107.686,1533.669l1.193,4.858,51.976,11.359,124.279-30.533",
    transform: "translate(108.01 -1519.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M-54.692,1550.035a.363.363,0,0,1-.069-.007l-51.976-11.36a.322.322,0,0,1-.246-.24l-1.193-4.858a.324.324,0,0,1,.238-.392.323.323,0,0,1,.392.238l1.145,4.661,51.7,11.3L69.51,1518.863a.324.324,0,1,1,.155.63l-124.279,30.533A.344.344,0,0,1-54.692,1550.035Z",
    transform: "translate(108.186 -1518.853)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(20.002 80.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M68.569,1505.744-55.71,1536.276l-51.976-11.359,124.279-30.533Z",
    transform: "translate(108.011 -1494.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M-55.885,1536.426a.349.349,0,0,1-.069-.007l-51.976-11.36a.324.324,0,0,1-.255-.313.324.324,0,0,1,.247-.319l124.279-30.533a.331.331,0,0,1,.147,0l51.976,11.359a.325.325,0,0,1,.008.633l-124.278,30.533A.344.344,0,0,1-55.885,1536.426Zm-50.54-11.7,50.537,11.044,122.846-30.181-50.536-11.044Z",
    transform: "translate(108.186 -1493.885)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(47.398 86.157)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    y1: 23.517,
    x2: 95.72,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M-65.681,1526.723a.325.325,0,0,1-.315-.247.325.325,0,0,1,.238-.393l95.72-23.516a.324.324,0,1,1,.155.63l-95.72,23.516A.316.316,0,0,1-65.681,1526.723Z",
    transform: "translate(66.006 -1502.557)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    transform: "translate(60.325 89.849)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    y1: 23.517,
    x2: 95.72,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M-45.779,1532.408a.325.325,0,0,1-.315-.247.325.325,0,0,1,.238-.393l95.72-23.517a.325.325,0,0,1,.155.631L-45.7,1532.4A.328.328,0,0,1-45.779,1532.408Z",
    transform: "translate(46.104 -1508.241)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(71.979 122.416)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x2: 1.193,
    y2: 4.858,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M-26.643,1563.89a.325.325,0,0,1-.315-.248l-1.193-4.858a.323.323,0,0,1,.238-.392.323.323,0,0,1,.392.238l1.194,4.858a.325.325,0,0,1-.238.393A.325.325,0,0,1-26.643,1563.89Z",
    transform: "translate(28.161 -1558.383)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280",
    transform: "translate(196.257 91.883)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x2: 1.193,
    y2: 4.858,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M164.7,1516.881a.324.324,0,0,1-.315-.247l-1.194-4.858a.324.324,0,1,1,.63-.155l1.194,4.858a.324.324,0,0,1-.238.392A.288.288,0,0,1,164.7,1516.881Z",
    transform: "translate(-163.183 -1511.373)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    transform: "translate(85.208 40.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 189.644,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M182.177,1265.64H-7.467a.325.325,0,0,1-.325-.325V1253.49a.325.325,0,0,1,.325-.325H182.177a.325.325,0,0,1,.325.325v11.825A.325.325,0,0,1,182.177,1265.64Zm-189.319-.65H181.852v-11.176H-7.142Z",
    transform: "translate(7.792 -1253.165)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(3.431 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M.02,1263.469a2.529,2.529,0,1,1,0-5.058,2.529,2.529,0,1,1,0,5.058Zm0-4.409a1.882,1.882,0,0,0-1.88,1.88,1.882,1.882,0,0,0,1.88,1.88,1.882,1.882,0,0,0,1.88-1.88A1.882,1.882,0,0,0,.02,1259.061Z",
    transform: "translate(2.509 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(2.095 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    transform: "translate(0)",
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    transform: "translate(10.428 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M10.793,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,10.793,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,10.793,1259.061Z",
    transform: "translate(-8.264 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(1.04 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M12.518,1262.454H10.19a.325.325,0,0,1,0-.65h2.328a.325.325,0,0,1,0,.65Z",
    transform: "translate(-9.865 -1261.805)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293",
    transform: "translate(17.425 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M21.565,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,21.565,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,21.565,1259.061Z",
    transform: "translate(-19.036 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(0.91 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    transform: "translate(1.294)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M22.755,1263.051a.325.325,0,0,1-.325-.325v-2.59a.325.325,0,0,1,.65,0v2.59A.324.324,0,0,1,22.755,1263.051Z",
    transform: "translate(-22.43 -1259.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x1: 2.59,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M23.351,1262.454h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,0,1,0,.65Z",
    transform: "translate(-20.437 -1261.805)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(85.208 51.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M-7.467,1360.615a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,0,1,.325-.325.325.325,0,0,1,.325.325v88.594A.325.325,0,0,1-7.467,1360.615Z",
    transform: "translate(7.792 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(274.852 51.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M284.516,1306.908a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,1,1,.65,0v34.887A.325.325,0,0,1,284.516,1306.908Z",
    transform: "translate(-284.191 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(274.852 69.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M318.737,1376.388a.325.325,0,0,1-.325-.325v-77.184h-33.9a.325.325,0,0,1,0-.65h34.221a.324.324,0,0,1,.325.325v77.509A.324.324,0,0,1,318.737,1376.388Z",
    transform: "translate(-284.191 -1298.229)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298",
    transform: "translate(97.953 68.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M28.208,1329.829a16.377,16.377,0,1,1,16.377-16.376A16.4,16.4,0,0,1,28.208,1329.829Zm0-32.1a15.727,15.727,0,1,0,15.728,15.728A15.745,15.745,0,0,0,28.208,1297.724Z",
    transform: "translate(-11.831 -1297.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(114.22 84.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M95.844,1352.3H37.2a.325.325,0,0,1-.325-.325v-29.536a.325.325,0,0,1,.325-.325H95.844a.325.325,0,0,1,.325.325v29.536A.325.325,0,0,1,95.844,1352.3Zm-58.319-.649H95.519v-28.887H37.525Z",
    transform: "translate(-36.875 -1322.119)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(181.425 89.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M191.858,1329.359H140.672a.325.325,0,0,1,0-.65h51.187a.325.325,0,0,1,0,.65Z",
    transform: "translate(-140.347 -1328.709)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M191.858,1341.551H140.672a.325.325,0,1,1,0-.649h51.187a.325.325,0,1,1,0,.649Z",
    transform: "translate(-140.347 -1340.902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(0 15.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M169.566,1353.745H140.672a.325.325,0,0,1,0-.65h28.894a.325.325,0,0,1,0,.65Z",
    transform: "translate(-140.347 -1353.095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(93.245 134.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M7.064,1402.877a2.483,2.483,0,1,1,2.484-2.484A2.486,2.486,0,0,1,7.064,1402.877Zm0-4.317a1.834,1.834,0,1,0,1.834,1.833A1.835,1.835,0,0,0,7.064,1398.56Z",
    transform: "translate(-4.582 -1397.911)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(7.048 0.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 2.158,
    cy: 2.158,
    r: 2.158
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    transform: "translate(13.772 0.491)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 2.158,
    cy: 2.158,
    r: 2.158
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(273.72 59.007)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(144.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(145.63 2.051)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    width: 0.65,
    height: 38.344,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(202.038 127.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    width: 76.846,
    height: 56.262,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M249.254,1444.37H172.408a.325.325,0,0,1-.325-.325v-56.262a.325.325,0,0,1,.325-.325h76.846a.324.324,0,0,1,.325.325v56.262A.324.324,0,0,1,249.254,1444.37Zm-76.521-.649h76.2v-55.613h-76.2Z",
    transform: "translate(-172.083 -1387.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(162.91 129.334)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 29.503,
    height: 24.701,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(237.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 189.644,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M416.731,1134.73H227.088a.324.324,0,0,1-.325-.325V1122.58a.325.325,0,0,1,.325-.325H416.731a.325.325,0,0,1,.325.325v11.825A.325.325,0,0,1,416.731,1134.73Zm-189.319-.649H416.407V1122.9H227.412Z",
    transform: "translate(-226.763 -1122.255)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(3.431 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M234.574,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,234.574,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,234.574,1128.15Z",
    transform: "translate(-232.045 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322",
    transform: "translate(2.096 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(10.428 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M245.347,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,245.347,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,245.347,1128.15Z",
    transform: "translate(-242.818 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(1.041 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M247.073,1131.544h-2.328a.325.325,0,0,1,0-.65h2.328a.325.325,0,0,1,0,.65Z",
    transform: "translate(-244.42 -1130.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(17.425 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M256.12,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,256.12,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,256.12,1128.15Z",
    transform: "translate(-253.591 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330",
    transform: "translate(0.909 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M257.31,1132.141a.324.324,0,0,1-.325-.325v-2.59a.325.325,0,1,1,.649,0v2.59A.325.325,0,0,1,257.31,1132.141Z",
    transform: "translate(-256.985 -1128.901)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x1: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M257.906,1131.544h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,0,1,0,.65Z",
    transform: "translate(-254.991 -1130.895)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(361.205 95.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 89.882,
    height: 115.955,
    transform: "translate(0.325 0.324)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M507.351,1385.6H417.469a.325.325,0,0,1-.325-.325V1269.317a.324.324,0,0,1,.325-.325h89.883a.325.325,0,0,1,.325.325v115.955A.325.325,0,0,1,507.351,1385.6Zm-89.558-.65h89.233V1269.642H417.793Z",
    transform: "translate(-417.144 -1268.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(245.59 20.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(36.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M306,1176.183a11.016,11.016,0,1,1,11.016-11.016A11.029,11.029,0,0,1,306,1176.183Zm0-21.382a10.366,10.366,0,1,0,10.366,10.366A10.378,10.378,0,0,0,306,1154.8Z",
    transform: "translate(-294.979 -1154.151)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(9.309 10.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M291.16,1216.89H253.8a.325.325,0,0,1-.325-.325v-46.158a.324.324,0,0,1,.325-.325H291.16a.324.324,0,0,1,.325.325v46.158A.325.325,0,0,1,291.16,1216.89Zm-37.039-.649h36.714v-45.509H254.12Z",
    transform: "translate(-253.471 -1170.082)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(0 25.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M250.125,1224.964a17.522,17.522,0,0,1-10.864-3.789.325.325,0,0,1-.052-.457l5.206-6.547a.325.325,0,0,1,.456-.053,8.361,8.361,0,0,0,5.254,1.831,8.454,8.454,0,0,0,4.723-15.464.325.325,0,0,1-.137-.207.322.322,0,0,1,.049-.244l4.682-6.932a.326.326,0,0,1,.451-.088,17.469,17.469,0,0,1-9.769,31.949Zm-10.2-4.1a16.819,16.819,0,1,0,19.877-27.128l-4.32,6.4a9.1,9.1,0,0,1-5.353,16.466,9,9,0,0,1-5.4-1.774Z",
    transform: "translate(-239.138 -1192.96)"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375-2",
    "data-name": "Group 1375",
    transform: "translate(144.473 4933.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1373-2",
    "data-name": "Group 1373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372-2",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367-2",
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366-2",
    "data-name": "Group 1366",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1365-2",
    "data-name": "Group 1365",
    transform: "translate(-251.078 39.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1272-2",
    "data-name": "Group 1272",
    transform: "translate(273.582 11.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138-2",
    "data-name": "Path 1138",
    d: "M436.349,1140.962v119.6H318.227v60.379H282.735V1141.006",
    transform: "translate(-282.41 -1140.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139-2",
    "data-name": "Path 1139",
    d: "M318.051,1321.091H282.56a.324.324,0,0,1-.325-.325V1140.831a.325.325,0,1,1,.65,0v179.61h34.842v-60.054a.325.325,0,0,1,.325-.325h117.8V1140.787a.325.325,0,1,1,.65,0v119.6a.325.325,0,0,1-.325.325h-117.8v60.054A.324.324,0,0,1,318.051,1321.091Z",
    transform: "translate(-282.235 -1140.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319-2",
    "data-name": "Group 1319",
    transform: "translate(0 44.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1281-2",
    "data-name": "Group 1281",
    transform: "translate(0 115.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1273-2",
    "data-name": "Group 1273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_818-2",
    "data-name": "Rectangle 818",
    d: "M7.442,0H120.533a7.442,7.442,0,0,1,7.442,7.442V82.913a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.442A7.442,7.442,0,0,1,7.442,0Z",
    transform: "translate(0 30.533) rotate(-13.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140-2",
    "data-name": "Path 1140",
    d: "M-118.829,1481.654a.322.322,0,0,1-.168-.047.322.322,0,0,1-.147-.2l-18.628-75.825a5.123,5.123,0,0,1,.6-3.9,5.122,5.122,0,0,1,3.181-2.337L-19.1,1371.116a5.164,5.164,0,0,1,6.24,3.778l18.628,75.825a.325.325,0,0,1-.238.393l-124.278,30.532A.318.318,0,0,1-118.829,1481.654Zm100.956-110.039a4.529,4.529,0,0,0-1.076.131l-114.891,28.227a4.514,4.514,0,0,0-3.3,5.455l18.551,75.509L5.056,1450.559l-18.55-75.51A4.519,4.519,0,0,0-17.873,1371.616Z",
    transform: "translate(138.611 -1370.278)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274-2",
    "data-name": "Group 1274",
    transform: "translate(8.03 9.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819-2",
    "data-name": "Rectangle 819",
    width: 114.496,
    height: 67.808,
    rx: 2,
    transform: "translate(0.053 27.37) rotate(-13.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141-2",
    "data-name": "Path 1141",
    d: "M-109.439,1477.457a1.609,1.609,0,0,1-.838-.236,1.61,1.61,0,0,1-.736-1l-15.558-63.327a1.61,1.61,0,0,1,.188-1.228,1.612,1.612,0,0,1,1-.736l108.666-26.7a1.613,1.613,0,0,1,1.228.188,1.611,1.611,0,0,1,.736,1L.807,1448.748a1.625,1.625,0,0,1-1.189,1.964h0l-108.666,26.7A1.612,1.612,0,0,1-109.439,1477.457Zm93.111-92.623a.987.987,0,0,0-.233.028l-108.667,26.7a.969.969,0,0,0-.6.442.971.971,0,0,0-.113.737l15.558,63.327a.977.977,0,0,0,1.179.714l108.666-26.7a.968.968,0,0,0,.6-.442.968.968,0,0,0,.113-.737l-15.558-63.327A.976.976,0,0,0-16.327,1384.834ZM-.459,1450.4h0Z",
    transform: "translate(126.619 -1384.183)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275-2",
    "data-name": "Group 1275",
    transform: "translate(20.002 96.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142-2",
    "data-name": "Path 1142",
    d: "M-107.686,1533.669l1.193,4.858,51.976,11.359,124.279-30.533",
    transform: "translate(108.01 -1519.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143-2",
    "data-name": "Path 1143",
    d: "M-54.692,1550.035a.363.363,0,0,1-.069-.007l-51.976-11.36a.322.322,0,0,1-.246-.24l-1.193-4.858a.324.324,0,0,1,.238-.392.323.323,0,0,1,.392.238l1.145,4.661,51.7,11.3L69.51,1518.863a.324.324,0,1,1,.155.63l-124.279,30.533A.344.344,0,0,1-54.692,1550.035Z",
    transform: "translate(108.186 -1518.853)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276-2",
    "data-name": "Group 1276",
    transform: "translate(20.002 80.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144-2",
    "data-name": "Path 1144",
    d: "M68.569,1505.744-55.71,1536.276l-51.976-11.359,124.279-30.533Z",
    transform: "translate(108.011 -1494.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145-2",
    "data-name": "Path 1145",
    d: "M-55.885,1536.426a.349.349,0,0,1-.069-.007l-51.976-11.36a.324.324,0,0,1-.255-.313.324.324,0,0,1,.247-.319l124.279-30.533a.331.331,0,0,1,.147,0l51.976,11.359a.325.325,0,0,1,.008.633l-124.278,30.533A.344.344,0,0,1-55.885,1536.426Zm-50.54-11.7,50.537,11.044,122.846-30.181-50.536-11.044Z",
    transform: "translate(108.186 -1493.885)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1277-2",
    "data-name": "Group 1277",
    transform: "translate(47.398 86.157)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_272-2",
    "data-name": "Line 272",
    y1: 23.517,
    x2: 95.72,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146-2",
    "data-name": "Path 1146",
    d: "M-65.681,1526.723a.325.325,0,0,1-.315-.247.325.325,0,0,1,.238-.393l95.72-23.516a.324.324,0,1,1,.155.63l-95.72,23.516A.316.316,0,0,1-65.681,1526.723Z",
    transform: "translate(66.006 -1502.557)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278-2",
    "data-name": "Group 1278",
    transform: "translate(60.325 89.849)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_273-2",
    "data-name": "Line 273",
    y1: 23.517,
    x2: 95.72,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147-2",
    "data-name": "Path 1147",
    d: "M-45.779,1532.408a.325.325,0,0,1-.315-.247.325.325,0,0,1,.238-.393l95.72-23.517a.325.325,0,0,1,.155.631L-45.7,1532.4A.328.328,0,0,1-45.779,1532.408Z",
    transform: "translate(46.104 -1508.241)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1279-2",
    "data-name": "Group 1279",
    transform: "translate(71.979 122.416)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_274-2",
    "data-name": "Line 274",
    x2: 1.193,
    y2: 4.858,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148-2",
    "data-name": "Path 1148",
    d: "M-26.643,1563.89a.325.325,0,0,1-.315-.248l-1.193-4.858a.323.323,0,0,1,.238-.392.323.323,0,0,1,.392.238l1.194,4.858a.325.325,0,0,1-.238.393A.325.325,0,0,1-26.643,1563.89Z",
    transform: "translate(28.161 -1558.383)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1280-2",
    "data-name": "Group 1280",
    transform: "translate(196.257 91.883)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_275-2",
    "data-name": "Line 275",
    x2: 1.193,
    y2: 4.858,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149-2",
    "data-name": "Path 1149",
    d: "M164.7,1516.881a.324.324,0,0,1-.315-.247l-1.194-4.858a.324.324,0,1,1,.63-.155l1.194,4.858a.324.324,0,0,1-.238.392A.288.288,0,0,1,164.7,1516.881Z",
    transform: "translate(-163.183 -1511.373)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1294-2",
    "data-name": "Group 1294",
    transform: "translate(85.208 40.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282-2",
    "data-name": "Group 1282",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820-2",
    "data-name": "Rectangle 820",
    width: 189.644,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150-2",
    "data-name": "Path 1150",
    d: "M182.177,1265.64H-7.467a.325.325,0,0,1-.325-.325V1253.49a.325.325,0,0,1,.325-.325H182.177a.325.325,0,0,1,.325.325v11.825A.325.325,0,0,1,182.177,1265.64Zm-189.319-.65H181.852v-11.176H-7.142Z",
    transform: "translate(7.792 -1253.165)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285-2",
    "data-name": "Group 1285",
    transform: "translate(3.431 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283-2",
    "data-name": "Group 1283",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204-2",
    "data-name": "Ellipse 204",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151-2",
    "data-name": "Path 1151",
    d: "M.02,1263.469a2.529,2.529,0,1,1,0-5.058,2.529,2.529,0,1,1,0,5.058Zm0-4.409a1.882,1.882,0,0,0-1.88,1.88,1.882,1.882,0,0,0,1.88,1.88,1.882,1.882,0,0,0,1.88-1.88A1.882,1.882,0,0,0,.02,1259.061Z",
    transform: "translate(2.509 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284-2",
    "data-name": "Group 1284",
    transform: "translate(2.095 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205-2",
    "data-name": "Ellipse 205",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    transform: "translate(0)",
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288-2",
    "data-name": "Group 1288",
    transform: "translate(10.428 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286-2",
    "data-name": "Group 1286",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206-2",
    "data-name": "Ellipse 206",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152-2",
    "data-name": "Path 1152",
    d: "M10.793,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,10.793,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,10.793,1259.061Z",
    transform: "translate(-8.264 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287-2",
    "data-name": "Group 1287",
    transform: "translate(1.04 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_276-2",
    "data-name": "Line 276",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153-2",
    "data-name": "Path 1153",
    d: "M12.518,1262.454H10.19a.325.325,0,0,1,0-.65h2.328a.325.325,0,0,1,0,.65Z",
    transform: "translate(-9.865 -1261.805)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1293-2",
    "data-name": "Group 1293",
    transform: "translate(17.425 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1289-2",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207-2",
    "data-name": "Ellipse 207",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154-2",
    "data-name": "Path 1154",
    d: "M21.565,1263.469a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,21.565,1263.469Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,21.565,1259.061Z",
    transform: "translate(-19.036 -1258.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292-2",
    "data-name": "Group 1292",
    transform: "translate(0.91 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290-2",
    "data-name": "Group 1290",
    transform: "translate(1.294)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_277-2",
    "data-name": "Line 277",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155-2",
    "data-name": "Path 1155",
    d: "M22.755,1263.051a.325.325,0,0,1-.325-.325v-2.59a.325.325,0,0,1,.65,0v2.59A.324.324,0,0,1,22.755,1263.051Z",
    transform: "translate(-22.43 -1259.811)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291-2",
    "data-name": "Group 1291",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_278-2",
    "data-name": "Line 278",
    x1: 2.59,
    transform: "translate(0.324 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156-2",
    "data-name": "Path 1156",
    d: "M23.351,1262.454h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,0,1,0,.65Z",
    transform: "translate(-20.437 -1261.805)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295-2",
    "data-name": "Group 1295",
    transform: "translate(85.208 51.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157-2",
    "data-name": "Path 1157",
    d: "M-7.467,1360.615a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,0,1,.325-.325.325.325,0,0,1,.325.325v88.594A.325.325,0,0,1-7.467,1360.615Z",
    transform: "translate(7.792 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296-2",
    "data-name": "Group 1296",
    transform: "translate(274.852 51.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158-2",
    "data-name": "Path 1158",
    d: "M284.516,1306.908a.325.325,0,0,1-.325-.325V1271.7a.325.325,0,1,1,.65,0v34.887A.325.325,0,0,1,284.516,1306.908Z",
    transform: "translate(-284.191 -1271.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297-2",
    "data-name": "Group 1297",
    transform: "translate(274.852 69.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159-2",
    "data-name": "Path 1159",
    d: "M318.737,1376.388a.325.325,0,0,1-.325-.325v-77.184h-33.9a.325.325,0,0,1,0-.65h34.221a.324.324,0,0,1,.325.325v77.509A.324.324,0,0,1,318.737,1376.388Z",
    transform: "translate(-284.191 -1298.229)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298-2",
    "data-name": "Group 1298",
    transform: "translate(97.953 68.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160-2",
    "data-name": "Path 1160",
    d: "M28.208,1329.829a16.377,16.377,0,1,1,16.377-16.376A16.4,16.4,0,0,1,28.208,1329.829Zm0-32.1a15.727,15.727,0,1,0,15.728,15.728A15.745,15.745,0,0,0,28.208,1297.724Z",
    transform: "translate(-11.831 -1297.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299-2",
    "data-name": "Group 1299",
    transform: "translate(114.22 84.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161-2",
    "data-name": "Path 1161",
    d: "M95.844,1352.3H37.2a.325.325,0,0,1-.325-.325v-29.536a.325.325,0,0,1,.325-.325H95.844a.325.325,0,0,1,.325.325v29.536A.325.325,0,0,1,95.844,1352.3Zm-58.319-.649H95.519v-28.887H37.525Z",
    transform: "translate(-36.875 -1322.119)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1303-2",
    "data-name": "Group 1303",
    transform: "translate(181.425 89.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300-2",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162-2",
    "data-name": "Path 1162",
    d: "M191.858,1329.359H140.672a.325.325,0,0,1,0-.65h51.187a.325.325,0,0,1,0,.65Z",
    transform: "translate(-140.347 -1328.709)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301-2",
    "data-name": "Group 1301",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163-2",
    "data-name": "Path 1163",
    d: "M191.858,1341.551H140.672a.325.325,0,1,1,0-.649h51.187a.325.325,0,1,1,0,.649Z",
    transform: "translate(-140.347 -1340.902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302-2",
    "data-name": "Group 1302",
    transform: "translate(0 15.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164-2",
    "data-name": "Path 1164",
    d: "M169.566,1353.745H140.672a.325.325,0,0,1,0-.65h28.894a.325.325,0,0,1,0,.65Z",
    transform: "translate(-140.347 -1353.095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(296.886 76.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 6.337,
    height: 0.65,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305",
    transform: "translate(0 3.298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 6.337,
    height: 0.65,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    transform: "translate(0 6.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_823",
    "data-name": "Rectangle 823",
    width: 3.577,
    height: 0.65,
    fill: "#0067ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1311-2",
    "data-name": "Group 1311",
    transform: "translate(93.245 134.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308-2",
    "data-name": "Group 1308",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165-2",
    "data-name": "Path 1165",
    d: "M7.064,1402.877a2.483,2.483,0,1,1,2.484-2.484A2.486,2.486,0,0,1,7.064,1402.877Zm0-4.317a1.834,1.834,0,1,0,1.834,1.833A1.835,1.835,0,0,0,7.064,1398.56Z",
    transform: "translate(-4.582 -1397.911)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309-2",
    "data-name": "Group 1309",
    transform: "translate(7.048 0.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208-2",
    "data-name": "Ellipse 208",
    cx: 2.158,
    cy: 2.158,
    r: 2.158
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1310-2",
    "data-name": "Group 1310",
    transform: "translate(13.772 0.491)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209-2",
    "data-name": "Ellipse 209",
    cx: 2.158,
    cy: 2.158,
    r: 2.158
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1312-2",
    "data-name": "Group 1312",
    transform: "translate(273.72 59.007)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210-2",
    "data-name": "Ellipse 210",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1313-2",
    "data-name": "Group 1313",
    transform: "translate(144.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211-2",
    "data-name": "Ellipse 211",
    cx: 1.715,
    cy: 1.715,
    r: 1.715
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(308.026 111.838)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    transform: "translate(0)",
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315-2",
    "data-name": "Group 1315",
    transform: "translate(145.63 2.051)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824-2",
    "data-name": "Rectangle 824",
    width: 0.65,
    height: 38.344,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316-2",
    "data-name": "Group 1316",
    transform: "translate(202.038 127.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825-2",
    "data-name": "Rectangle 825",
    width: 76.846,
    height: 56.262,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166-2",
    "data-name": "Path 1166",
    d: "M249.254,1444.37H172.408a.325.325,0,0,1-.325-.325v-56.262a.325.325,0,0,1,.325-.325h76.846a.324.324,0,0,1,.325.325v56.262A.324.324,0,0,1,249.254,1444.37Zm-76.521-.649h76.2v-55.613h-76.2Z",
    transform: "translate(-172.083 -1387.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(276.712 60.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M333.517,1337.576H321.361v-.65h12.155a2.1,2.1,0,0,0,2.1-2.1v-47.943a2.1,2.1,0,0,0-2.1-2.1H287.055v-.65h46.462a2.754,2.754,0,0,1,2.751,2.751v47.943A2.754,2.754,0,0,1,333.517,1337.576Z",
    transform: "translate(-287.055 -1284.132)",
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318-2",
    "data-name": "Group 1318",
    transform: "translate(162.91 129.334)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826-2",
    "data-name": "Rectangle 826",
    width: 29.503,
    height: 24.701,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332-2",
    "data-name": "Group 1332",
    transform: "translate(237.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320-2",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827-2",
    "data-name": "Rectangle 827",
    width: 189.644,
    height: 11.825,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168-2",
    "data-name": "Path 1168",
    d: "M416.731,1134.73H227.088a.324.324,0,0,1-.325-.325V1122.58a.325.325,0,0,1,.325-.325H416.731a.325.325,0,0,1,.325.325v11.825A.325.325,0,0,1,416.731,1134.73Zm-189.319-.649H416.407V1122.9H227.412Z",
    transform: "translate(-226.763 -1122.255)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323-2",
    "data-name": "Group 1323",
    transform: "translate(3.431 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321-2",
    "data-name": "Group 1321"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213-2",
    "data-name": "Ellipse 213",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169-2",
    "data-name": "Path 1169",
    d: "M234.574,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,234.574,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,234.574,1128.15Z",
    transform: "translate(-232.045 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1322-2",
    "data-name": "Group 1322",
    transform: "translate(2.096 2.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214-2",
    "data-name": "Ellipse 214",
    cx: 0.434,
    cy: 0.434,
    r: 0.434,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326-2",
    "data-name": "Group 1326",
    transform: "translate(10.428 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324-2",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215-2",
    "data-name": "Ellipse 215",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170-2",
    "data-name": "Path 1170",
    d: "M245.347,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,245.347,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,245.347,1128.15Z",
    transform: "translate(-242.818 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325-2",
    "data-name": "Group 1325",
    transform: "translate(1.041 2.204)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_279-2",
    "data-name": "Line 279",
    x2: 2.328,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171-2",
    "data-name": "Path 1171",
    d: "M247.073,1131.544h-2.328a.325.325,0,0,1,0-.65h2.328a.325.325,0,0,1,0,.65Z",
    transform: "translate(-244.42 -1130.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331-2",
    "data-name": "Group 1331",
    transform: "translate(17.425 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1327-2",
    "data-name": "Group 1327"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216-2",
    "data-name": "Ellipse 216",
    cx: 2.204,
    cy: 2.204,
    r: 2.204,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172-2",
    "data-name": "Path 1172",
    d: "M256.12,1132.559a2.529,2.529,0,1,1,2.529-2.529A2.532,2.532,0,0,1,256.12,1132.559Zm0-4.409a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,256.12,1128.15Z",
    transform: "translate(-253.591 -1127.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1330-2",
    "data-name": "Group 1330",
    transform: "translate(0.909 0.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328-2",
    "data-name": "Group 1328",
    transform: "translate(1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_280-2",
    "data-name": "Line 280",
    y2: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173-2",
    "data-name": "Path 1173",
    d: "M257.31,1132.141a.324.324,0,0,1-.325-.325v-2.59a.325.325,0,1,1,.649,0v2.59A.325.325,0,0,1,257.31,1132.141Z",
    transform: "translate(-256.985 -1128.901)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329-2",
    "data-name": "Group 1329",
    transform: "translate(0 1.295)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_281-2",
    "data-name": "Line 281",
    x1: 2.59,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174-2",
    "data-name": "Path 1174",
    d: "M257.906,1131.544h-2.59a.325.325,0,0,1,0-.65h2.59a.325.325,0,0,1,0,.65Z",
    transform: "translate(-254.991 -1130.895)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(308.424 48.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M412.736,1198.749H336.853a.974.974,0,1,1,0-1.948h75.883a.974.974,0,1,1,0,1.948Z",
    transform: "translate(-335.879 -1196.8)",
    fill: "#ff3900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M412.736,1210.94H336.853a.974.974,0,1,1,0-1.948h75.883a.974.974,0,1,1,0,1.948Z",
    transform: "translate(-335.879 -1208.992)",
    fill: "#ff3900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(0 15.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M379.688,1223.133H336.853a.974.974,0,1,1,0-1.948h42.835a.974.974,0,1,1,0,1.948Z",
    transform: "translate(-335.879 -1221.185)",
    fill: "#ff3900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337-2",
    "data-name": "Group 1337",
    transform: "translate(361.205 95.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828-2",
    "data-name": "Rectangle 828",
    width: 89.882,
    height: 115.955,
    transform: "translate(0.325 0.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178-2",
    "data-name": "Path 1178",
    d: "M507.351,1385.6H417.469a.325.325,0,0,1-.325-.325V1269.317a.324.324,0,0,1,.325-.325h89.883a.325.325,0,0,1,.325.325v115.955A.325.325,0,0,1,507.351,1385.6Zm-89.558-.65h89.233V1269.642H417.793Z",
    transform: "translate(-417.144 -1268.992)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342-2",
    "data-name": "Group 1342",
    transform: "translate(245.59 20.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1338-2",
    "data-name": "Group 1338",
    transform: "translate(36.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179-2",
    "data-name": "Path 1179",
    d: "M306,1176.183a11.016,11.016,0,1,1,11.016-11.016A11.029,11.029,0,0,1,306,1176.183Zm0-21.382a10.366,10.366,0,1,0,10.366,10.366A10.378,10.378,0,0,0,306,1154.8Z",
    transform: "translate(-294.979 -1154.151)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339-2",
    "data-name": "Group 1339",
    transform: "translate(9.309 10.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180-2",
    "data-name": "Path 1180",
    d: "M291.16,1216.89H253.8a.325.325,0,0,1-.325-.325v-46.158a.324.324,0,0,1,.325-.325H291.16a.324.324,0,0,1,.325.325v46.158A.325.325,0,0,1,291.16,1216.89Zm-37.039-.649h36.714v-45.509H254.12Z",
    transform: "translate(-253.471 -1170.082)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341-2",
    "data-name": "Group 1341",
    transform: "translate(0 25.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340-2",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181-2",
    "data-name": "Path 1181",
    d: "M250.125,1224.964a17.522,17.522,0,0,1-10.864-3.789.325.325,0,0,1-.052-.457l5.206-6.547a.325.325,0,0,1,.456-.053,8.361,8.361,0,0,0,5.254,1.831,8.454,8.454,0,0,0,4.723-15.464.325.325,0,0,1-.137-.207.322.322,0,0,1,.049-.244l4.682-6.932a.326.326,0,0,1,.451-.088,17.469,17.469,0,0,1-9.769,31.949Zm-10.2-4.1a16.819,16.819,0,1,0,19.877-27.128l-4.32,6.4a9.1,9.1,0,0,1-5.353,16.466,9,9,0,0,1-5.4-1.774Z",
    transform: "translate(-239.138 -1192.96)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(370.292 105.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(35.179 36.269)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 10.691,
    cy: 10.691,
    r: 10.691,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(0.056 9.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 37.364,
    height: 46.159,
    transform: "translate(46.159 0) rotate(90)",
    fill: "#fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M431.134,1294.786a17.2,17.2,0,0,1,3.718-10.662l6.548,5.206a8.682,8.682,0,0,0-1.9,5.457,8.778,8.778,0,0,0,16.058,4.9l6.932,4.683a17.144,17.144,0,0,1-31.355-9.587Z",
    transform: "translate(-431.134 -1284.124)",
    fill: "#ffc0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349",
    transform: "translate(35.179 36.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347",
    transform: "translate(-35.123 -26.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 37.364,
    height: 46.159,
    transform: "translate(46.159 0) rotate(90)",
    fill: "#fffaf0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353",
    transform: "translate(0.056 9.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(-0.056 -9.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M431.134,1294.786a17.2,17.2,0,0,1,3.718-10.662l6.548,5.206a8.682,8.682,0,0,0-1.9,5.457,8.778,8.778,0,0,0,16.058,4.9l6.932,4.683a17.144,17.144,0,0,1-31.355-9.587Z",
    transform: "translate(-431.134 -1284.124)",
    fill: "#ff3900"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(369.992 173.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M491.852,1389.568H431a.325.325,0,0,1,0-.65h60.855a.325.325,0,0,1,0,.65Z",
    transform: "translate(-430.672 -1388.918)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(0 7.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M491.852,1401.76H431a.325.325,0,1,1,0-.649h60.855a.325.325,0,1,1,0,.649Z",
    transform: "translate(-430.672 -1401.111)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    transform: "translate(0 15.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M465.348,1413.954H431a.325.325,0,0,1,0-.65h34.352a.325.325,0,0,1,0,.65Z",
    transform: "translate(-430.672 -1413.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364",
    transform: "translate(310.227 75.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 45.466,
    height: 13.812,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    transform: "translate(18.531 5.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M370.4,1247.511a2.081,2.081,0,0,1-.11.688,1.62,1.62,0,0,1-.316.547,1.455,1.455,0,0,1-.5.362,1.623,1.623,0,0,1-.662.13,1.557,1.557,0,0,1-.66-.137,1.623,1.623,0,0,1-.511-.367,1.655,1.655,0,0,1-.33-.529,1.721,1.721,0,0,1-.117-.63,1.7,1.7,0,0,1,.463-1.171,1.594,1.594,0,0,1,.513-.36,1.564,1.564,0,0,1,.646-.133,1.863,1.863,0,0,1,.525.069,1.57,1.57,0,0,1,.422.19,1.35,1.35,0,0,1,.318.288,1.5,1.5,0,0,1,.211.36h-.422a.934.934,0,0,0-.392-.41,1.3,1.3,0,0,0-.662-.158,1.205,1.205,0,0,0-.516.106,1.161,1.161,0,0,0-.385.284,1.263,1.263,0,0,0-.243.415,1.475,1.475,0,0,0-.085.5,1.529,1.529,0,0,0,.1.554,1.26,1.26,0,0,0,.266.424,1.147,1.147,0,0,0,.4.27,1.288,1.288,0,0,0,.5.094,1.173,1.173,0,0,0,.442-.082,1.1,1.1,0,0,0,.6-.568,1.326,1.326,0,0,0,.114-.43h-1.339v-.349H370.4Z",
    transform: "translate(-367.187 -1245.911)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(3.55 0.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M372.742,1248.087a1.1,1.1,0,0,1,.621-.614,1.28,1.28,0,0,1,.935,0,1.117,1.117,0,0,1,.371.245,1.1,1.1,0,0,1,.243.372,1.214,1.214,0,0,1,.087.462,1.188,1.188,0,0,1-.087.457,1.138,1.138,0,0,1-.246.374,1.188,1.188,0,0,1-.373.254,1.155,1.155,0,0,1-.468.094,1.174,1.174,0,0,1-.837-.342,1.145,1.145,0,0,1-.247-.374,1.251,1.251,0,0,1,0-.93Zm.35.809a.87.87,0,0,0,.175.268.766.766,0,0,0,.559.238.791.791,0,0,0,.321-.064.742.742,0,0,0,.252-.179.836.836,0,0,0,.165-.27.933.933,0,0,0,.059-.335.923.923,0,0,0-.057-.327.832.832,0,0,0-.16-.268.745.745,0,0,0-.252-.181.838.838,0,0,0-.648,0,.759.759,0,0,0-.252.176.808.808,0,0,0-.165.266.908.908,0,0,0-.06.336A.89.89,0,0,0,373.092,1248.9Z",
    transform: "translate(-372.652 -1247.386)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(6.388 0.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M377.389,1248.326h-.33l-.037-2.26h.4Zm.036.463v.4h-.4v-.4Z",
    transform: "translate(-377.022 -1246.066)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    transform: "translate(162.286 248.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(-9 18.466)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 1.715,
    cy: 1.715,
    r: 1.715,
    fill: "#0067ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370",
    transform: "translate(-7.521 1.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 0.65,
    height: 18.317,
    fill: "#0067ec"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374",
    transform: "translate(31.354 33.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M296.185,1339.426a.325.325,0,0,1-.291-.467,551.671,551.671,0,0,0,23.211-53.785c2.353-6.5-2.045-14.392-6.3-22.022-4.178-7.495-8.5-15.245-6.366-21.709,3.781-11.464,12.361-16.238,19.931-20.45,8.387-4.666,15.63-8.7,15.159-20.3-.961-23.711,8.8-32.746,17.4-40.718,7.024-6.5,13.091-12.122,12.524-24.313a94.989,94.989,0,0,0-3.5-21.056.325.325,0,1,1,.625-.175,95.628,95.628,0,0,1,3.522,21.2c.581,12.493-5.885,18.48-12.732,24.82-8.5,7.876-18.145,16.8-17.2,40.215.486,12-7.275,16.319-15.493,20.891-7.466,4.154-15.928,8.862-19.63,20.085-2.043,6.194,2.206,13.817,6.316,21.189,4.324,7.757,8.795,15.778,6.342,22.559a552.288,552.288,0,0,1-23.239,53.849A.325.325,0,0,1,296.185,1339.426Z",
    transform: "translate(-295.861 -1114.197)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(193.683 5170.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    transform: "translate(1.098 1.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M344.586,1502.447l7.8-10.032-.471,12.7,12.426-2.669-8.524,9.427,11.235,5.943-12.59,1.742,14.729,20.531-20.706-15.515-3.9,12.1-3.9-12.1-10.764,6.758,4.786-11.774-12.59-1.742,11.235-5.943-8.524-9.427,12.426,2.669-.471-12.7Z",
    transform: "translate(-321.668 -1491.987)",
    fill: "#ffc0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M369.485,1540.41l-21.277-15.942-3.975,12.322-3.979-12.338-10.979,6.893,4.882-12.009-12.841-1.777,11.459-6.062-8.695-9.615,12.675,2.722-.48-12.955,7.959,10.233,7.959-10.233-.48,12.955,12.674-2.722-8.694,9.615,11.458,6.062-12.789,1.77Zm-21.423-16.4L368.2,1539.1l-14.334-19.981,12.39-1.715-11.01-5.824,8.354-9.239-12.178,2.616.461-12.447-7.648,9.831-7.647-9.831.461,12.447-12.178-2.616,8.354,9.239-11.01,5.824,12.338,1.707-4.69,11.539,10.549-6.623,3.824,11.854Z",
    transform: "translate(-321.315 -1491.65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(29.85 1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M375.887,1494.619h-2.8a.07.07,0,0,1-.07-.07v-2.805a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.805A.07.07,0,0,1,375.887,1494.619Zm-2.734-.14h2.664v-2.665h-2.664Z",
    transform: "translate(-373.013 -1491.674)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M375.366,1494.1h-2.617a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.617a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,375.366,1494.1Zm-2.547-.14H375.3v-2.478h-2.478Z",
    transform: "translate(-372.679 -1491.34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(14.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M348.688,1492.83h-2.8a.07.07,0,0,1-.07-.07v-2.805a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.805A.07.07,0,0,1,348.688,1492.83Zm-2.735-.14h2.665v-2.665h-2.665Z",
    transform: "translate(-345.813 -1489.885)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M348.167,1492.309h-2.618a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.618a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,348.167,1492.309Zm-2.548-.14H348.1v-2.478h-2.478Z",
    transform: "translate(-345.479 -1489.551)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    transform: "translate(2.804 10.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M327.572,1511.8h-2.8a.07.07,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,327.572,1511.8Zm-2.735-.14H327.5v-2.665h-2.665Z",
    transform: "translate(-324.697 -1508.853)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M327.051,1511.277h-2.618a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.618a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,327.051,1511.277Zm-2.548-.14h2.478v-2.478H324.5Z",
    transform: "translate(-324.363 -1508.519)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(0 24.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M322.561,1537.208h-2.8a.07.07,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,322.561,1537.208Zm-2.734-.14h2.664V1534.4h-2.664Z",
    transform: "translate(-319.687 -1534.263)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M322.04,1536.687h-2.617a.07.07,0,0,1-.07-.07V1534a.07.07,0,0,1,.07-.07h2.617a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,322.04,1536.687Zm-2.548-.14h2.478v-2.478h-2.478Z",
    transform: "translate(-319.353 -1533.929)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575",
    transform: "translate(7.613 38.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M336.161,1561.9h-2.8a.07.07,0,0,1-.07-.07v-2.805a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.805A.07.07,0,0,1,336.161,1561.9Zm-2.734-.14h2.664V1559.1h-2.664Z",
    transform: "translate(-333.287 -1558.958)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M335.64,1561.382h-2.617a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.617a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,335.64,1561.382Zm-2.548-.14h2.478v-2.478h-2.478Z",
    transform: "translate(-332.953 -1558.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578",
    transform: "translate(22.637 44.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M363,1572.282h-2.8a.071.071,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07H363a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,363,1572.282Zm-2.735-.14h2.665v-2.665h-2.665Z",
    transform: "translate(-360.128 -1569.337)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M362.482,1571.761h-2.618a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.618a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,362.482,1571.761Zm-2.548-.14h2.478v-2.478h-2.478Z",
    transform: "translate(-359.794 -1569.003)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(47.081 47.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M406.67,1577.913h-2.8a.07.07,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,406.67,1577.913Zm-2.735-.14H406.6v-2.664h-2.665Z",
    transform: "translate(-403.795 -1574.969)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M406.149,1577.393h-2.618a.071.071,0,0,1-.07-.07V1574.7a.07.07,0,0,1,.07-.07h2.618a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,406.149,1577.393Zm-2.548-.14h2.478v-2.478H403.6Z",
    transform: "translate(-403.461 -1574.635)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    transform: "translate(44.474 25.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M402.013,1538.282h-2.8a.07.07,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,402.013,1538.282Zm-2.734-.14h2.664v-2.665h-2.664Z",
    transform: "translate(-399.139 -1535.337)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M401.492,1537.761h-2.617a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07h2.617a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,401.492,1537.761Zm-2.547-.14h2.478v-2.478h-2.478Z",
    transform: "translate(-398.805 -1535.003)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(42.07 10.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(0.187 0.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 2.805,
    height: 2.805,
    transform: "translate(0.07 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M397.719,1511.44h-2.8a.07.07,0,0,1-.07-.07v-2.8a.07.07,0,0,1,.07-.07h2.8a.07.07,0,0,1,.07.07v2.8A.07.07,0,0,1,397.719,1511.44Zm-2.735-.14h2.665v-2.665h-2.665Z",
    transform: "translate(-394.844 -1508.495)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 2.618,
    height: 2.618,
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M397.2,1510.919H394.58a.07.07,0,0,1-.07-.07v-2.618a.07.07,0,0,1,.07-.07H397.2a.07.07,0,0,1,.07.07v2.618A.07.07,0,0,1,397.2,1510.919Zm-2.548-.14h2.478V1508.3H394.65Z",
    transform: "translate(-394.51 -1508.161)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(286.971 5018.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(55.291 1.128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 0.554,
    cy: 0.574,
    rx: 0.554,
    ry: 0.574
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(3.021 1.128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 0.554,
    cy: 0.574,
    rx: 0.554,
    ry: 0.574
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    transform: "translate(3.508 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M479.3,1562.948H427.176a.12.12,0,1,1,0-.24H479.3a.12.12,0,0,1,0,.24Z",
    transform: "translate(-427.056 -1562.707)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594",
    transform: "translate(1.849 1.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M451.289,1620.558c-15.263,0-27.681-12.849-27.681-28.643s12.418-28.643,27.681-28.643,27.682,12.849,27.682,28.643S466.553,1620.558,451.289,1620.558Zm0-57.045c-15.131,0-27.441,12.741-27.441,28.4s12.31,28.4,27.441,28.4,27.441-12.741,27.441-28.4S466.42,1563.513,451.289,1563.513Z",
    transform: "translate(-423.608 -1563.273)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597",
    transform: "translate(27.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595",
    transform: "translate(0.231 0.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 3.468,
    height: 3.589,
    transform: "translate(0.12 0.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M481.131,1563.747h-3.469a.12.12,0,0,1-.12-.12v-3.589a.12.12,0,0,1,.12-.12h3.469a.12.12,0,0,1,.12.12v3.589A.12.12,0,0,1,481.131,1563.747Zm-3.348-.24h3.228v-3.349h-3.228Z",
    transform: "translate(-477.542 -1559.917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 3.237,
    height: 3.35,
    transform: "translate(0.12 0.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M480.419,1563.01h-3.237a.12.12,0,0,1-.12-.12v-3.35a.12.12,0,0,1,.12-.12h3.237a.12.12,0,0,1,.12.12v3.35A.12.12,0,0,1,480.419,1563.01Zm-3.117-.241h3v-3.11h-3Z",
    transform: "translate(-477.062 -1559.419)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(27.561 56.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(0.231 0.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 3.468,
    height: 3.589,
    transform: "translate(0.12 0.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M481.131,1681.661h-3.469a.12.12,0,0,1-.12-.12v-3.589a.12.12,0,0,1,.12-.12h3.469a.12.12,0,0,1,.12.12v3.589A.12.12,0,0,1,481.131,1681.661Zm-3.348-.24h3.228v-3.349h-3.228Z",
    transform: "translate(-477.542 -1677.831)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 3.237,
    height: 3.35,
    transform: "translate(0.12 0.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M480.419,1680.924h-3.237a.12.12,0,0,1-.12-.12v-3.35a.12.12,0,0,1,.12-.12h3.237a.12.12,0,0,1,.12.12v3.35A.12.12,0,0,1,480.419,1680.924Zm-3.117-.24h3v-3.11h-3Z",
    transform: "translate(-477.062 -1677.333)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(55.439 28.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(0.231 0.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 3.468,
    height: 3.589,
    transform: "translate(0.12 0.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M539.088,1622.919H535.62a.12.12,0,0,1-.12-.12v-3.589a.12.12,0,0,1,.12-.12h3.468a.12.12,0,0,1,.12.12v3.589A.12.12,0,0,1,539.088,1622.919Zm-3.348-.24h3.228v-3.349H535.74Z",
    transform: "translate(-535.5 -1619.089)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 3.237,
    height: 3.35,
    transform: "translate(0.12 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M538.377,1622.182H535.14a.12.12,0,0,1-.12-.12v-3.35a.12.12,0,0,1,.12-.12h3.237a.12.12,0,0,1,.12.12v3.35A.12.12,0,0,1,538.377,1622.182Zm-3.116-.241h3v-3.109h-3Z",
    transform: "translate(-535.02 -1618.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(0 28.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(0.231 0.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 3.468,
    height: 3.589,
    transform: "translate(0.12 0.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M423.832,1622.919h-3.468a.12.12,0,0,1-.12-.12v-3.589a.12.12,0,0,1,.12-.12h3.468a.12.12,0,0,1,.12.12v3.589A.12.12,0,0,1,423.832,1622.919Zm-3.348-.24h3.228v-3.349h-3.228Z",
    transform: "translate(-420.243 -1619.089)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 3.237,
    height: 3.35,
    transform: "translate(0.12 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M423.12,1622.182h-3.237a.12.12,0,0,1-.12-.12v-3.35a.12.12,0,0,1,.12-.12h3.237a.12.12,0,0,1,.12.12v3.35A.12.12,0,0,1,423.12,1622.182Zm-3.117-.241h3v-3.109h-3Z",
    transform: "translate(-419.763 -1618.592)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(215.691 4928.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(-89.451 5.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M70.712,1105.049c-2.3,2.448-6.042,7.214-3.1,10.54,2.1,2.377,5.937,1.326,8.02-.44,2.656-2.252,4.236-7.252,2.277-10.379-1.687-2.693-5.531-2.562-8.2-1.819-2.99.831-6.216,2.914-7.05,6.079a5.219,5.219,0,0,0,5.586,6.5,11.973,11.973,0,0,0,9.413-7.025,5.657,5.657,0,0,0-4.6-7.862c-5.076-.776-12.233,3.555-9.042,9.259a.346.346,0,0,0,.6-.349c-2.538-4.537,2.383-7.9,6.465-8.275a5.966,5.966,0,0,1,5.525,2.12c1.378,1.923.878,4.3-.277,6.178-1.966,3.2-7.934,7.35-11.559,4.325a4.889,4.889,0,0,1-1.218-5.385,8.036,8.036,0,0,1,3.648-3.765c2.434-1.409,5.92-2.254,8.572-.968,3.4,1.65,2.4,6.51.864,9.109-1.5,2.538-5.049,4.414-7.844,2.775-4.024-2.359.513-8.1,2.415-10.125.305-.324-.184-.815-.49-.489Z",
    transform: "translate(-62.474 -1100.549)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(-100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M50.831,1093.551l-.371,12.816.759-.1a46.742,46.742,0,0,1-2.678-11.166c-.242-2.287.368-2.529,2.563-2.393q2.835.174,5.672.308c7.167.34,14.343.5,21.519.532,14.4.072,28.791-.341,43.181-.757v-.773q-37.361,2.925-74.871,2.256a.387.387,0,0,0,0,.774q37.47.655,74.871-2.256c.49-.038.5-.788,0-.773-24.5.707-49.039,1.381-73.517-.29a.389.389,0,0,0-.386.386,47.245,47.245,0,0,0,2.9,14.357.388.388,0,0,0,.759-.1l.372-12.816a.387.387,0,0,0-.774,0Z",
    transform: "translate(-46.231 -1091.725)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(75.022 0.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M161.882,1093a109.619,109.619,0,0,1-.142,11.392c-.032.5.741.495.773,0a109.621,109.621,0,0,0,.143-11.392c-.02-.5-.793-.5-.774,0Z",
    transform: "translate(-161.738 -1092.632)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(76.88 1.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M164.688,1094.333q-.262,10.955.248,21.9c.023.5.8.5.774,0q-.51-10.948-.248-21.9a.387.387,0,0,0-.774,0Z",
    transform: "translate(-164.599 -1093.96)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    transform: "translate(-67.32 7.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M96.918,1104.14q16.931-1.08,33.9-.651a.387.387,0,0,0,0-.774q-16.96-.431-33.9.651c-.494.032-.5.805,0,.773Z",
    transform: "translate(-96.546 -1102.593)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(0.396 5.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M97.53,1112.475h22.112a.387.387,0,0,0,0-.773H97.53a.387.387,0,0,0,0,.773Z",
    transform: "translate(-97.157 -1111.702)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(1.137 9.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M99.017,1120.426c3.107-5.618,5.108-.156,6.976.713a4.854,4.854,0,0,0,2.716.167c4.534-.647,8.1-1.463,12.677-.295a.387.387,0,0,0,.205-.746,22.943,22.943,0,0,0-7.9-.716,32.173,32.173,0,0,0-3.42.6c-2.692.546-2.486.686-5.329-1.116-2.465-1.563-4.92-2.025-6.594,1-.241.436.427.826.668.391Z",
    transform: "translate(-98.298 -1117.808)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(-95.508 24.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M53.522,1130.835q35.6-1.185,71.216-.7a.387.387,0,0,0,0-.774q-35.612-.481-71.216.7c-.5.017-.5.79,0,.773Z",
    transform: "translate(-53.148 -1129.218)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(-1.651 4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(33.68 101.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M87.395,756.468c.018-.506.048-1.026.087-1.562V754.9a20.023,20.023,0,1,1,33.009,17.067l-5.136,14.685,3.941,12.712a5.96,5.96,0,0,1-11.386,3.53l-8.261-27.322c-1.4.031-4.874-.07-4.874-.07C94.539,775.4,86.74,771.987,87.395,756.468Z",
    transform: "translate(-87.031 -736.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M113.439,807.235a6.306,6.306,0,0,1-6.014-4.421l-8.191-27.09c-1.5.016-4.509-.07-4.644-.074l-.114-.024c-.336-.137-8.246-3.549-7.58-19.344.017-.51.048-1.033.088-1.574a20.347,20.347,0,1,1,33.61,17.271l-5.073,14.5,3.909,12.61a6.279,6.279,0,0,1-5.991,8.144Zm-13.726-32.17,8.332,27.558a5.635,5.635,0,0,0,10.764-3.34l-3.972-12.814,5.2-14.868.066-.056A19.7,19.7,0,1,0,87.63,754.754c-.038.534-.069,1.049-.086,1.551v0c-.62,14.7,6.464,18.384,7.128,18.695.481.014,3.526.1,4.793.068Z",
    transform: "translate(-86.856 -736.276)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(0.039 18.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M87.416,766.254c0-.523.035-1.047.087-1.562C87.464,765.228,87.434,765.748,87.416,766.254Z",
    transform: "translate(-87.091 -764.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M87.566,766.247l-.65-.014c0-.52.034-1.055.089-1.593l.647.057C87.613,765.23,87.582,765.745,87.566,766.247Z",
    transform: "translate(-86.916 -764.641)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(13.921 13.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M108.572,772.294s7.682-5.262,6.024-14.889",
    transform: "translate(-108.388 -757.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M108.656,772.532l-.367-.535c.075-.052,7.49-5.265,5.888-14.566l.64-.11C116.492,767.04,108.735,772.478,108.656,772.532Z",
    transform: "translate(-108.289 -757.32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(23.838 16.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M131.126,761.676s-4.491,1.669-7.34.2",
    transform: "translate(-123.637 -761.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M126.618,762.643a6.685,6.685,0,0,1-3.061-.646l.3-.577c2.686,1.388,7.034-.2,7.078-.212l.226.609A14.613,14.613,0,0,1,126.618,762.643Z",
    transform: "translate(-123.557 -761.208)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(39.484 120.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(0 15.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M96.807,826.591a23.1,23.1,0,0,1,3.257-17.5,9.877,9.877,0,0,0,1.667-5.521l-.127-9.954,26.951-3.937,2.726,9.575a9.867,9.867,0,0,0,3.172,4.81,23.18,23.18,0,1,1-37.646,22.533Z",
    transform: "translate(-95.967 -789.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M119.262,845.063a23.534,23.534,0,0,1-22.948-18.6h0a23.368,23.368,0,0,1,3.3-17.748,9.545,9.545,0,0,0,1.614-5.34l-.131-10.238,27.514-4.02,2.8,9.848a9.526,9.526,0,0,0,3.07,4.65,23.5,23.5,0,0,1-13.434,41.38C120.453,845.04,119.855,845.063,119.262,845.063ZM101.755,793.7l.124,9.669a10.19,10.19,0,0,1-1.72,5.7,22.726,22.726,0,0,0-3.211,17.259h0a22.857,22.857,0,1,0,37.119-22.217,10.17,10.17,0,0,1-3.275-4.969l-2.648-9.3Z",
    transform: "translate(-95.791 -789.116)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(12.837 17.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M117.713,823.454a2.427,2.427,0,0,1-.419-.038c-1.079-.192-1.761-1.274-1.737-2.754a7.45,7.45,0,0,1,3.843-5.934l-.872-21.9.649-.026.859,21.553A15.82,15.82,0,0,1,130.43,813l-5.383-21.05.629-.161,5.475,21.412a7.816,7.816,0,0,1,5.29,4.626c.42,1.328.1,2.445-.833,2.915a1.884,1.884,0,0,1-1.722.059c-1.687-.79-2.5-4.028-2.569-4.334h0l-.7-2.753a13.7,13.7,0,0,0-5.65-.244,13.534,13.534,0,0,0-4.9,1.6l.12,3.019h0c.018.314.169,3.648-1.222,4.887A1.819,1.819,0,0,1,117.713,823.454Zm1.717-7.979a6.85,6.85,0,0,0-3.223,5.2c-.018,1.144.453,1.971,1.2,2.1a1.25,1.25,0,0,0,1.12-.282c.993-.885,1.062-3.463,1-4.381h0Zm12.516.825c.209.9,1.015,3.349,2.217,3.911a1.252,1.252,0,0,0,1.154-.051c.629-.317.823-1.137.506-2.14a7.007,7.007,0,0,0-4.48-4.076l.6,2.356Z",
    transform: "translate(-115.556 -791.787)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(3.248 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    d: "M0,0H27.237a0,0,0,0,1,0,0V1.159A13.619,13.619,0,0,1,13.619,14.778h0A13.619,13.619,0,0,1,0,1.159V0A0,0,0,0,1,0,0Z",
    transform: "translate(29.088 14.623) rotate(171.688)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(3.07 45.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M107.473,852.017a19.936,19.936,0,0,1-6.161-18.1",
    transform: "translate(-100.693 -833.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M107.078,852.227a20.264,20.264,0,0,1-6.262-18.391l.64.111a19.616,19.616,0,0,0,6.061,17.8Z",
    transform: "translate(-100.518 -833.836)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(12.497 65.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M120.42,867.4a19.817,19.817,0,0,1-5.121-2.3",
    transform: "translate(-115.126 -864.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M120.237,867.569a20.12,20.12,0,0,1-5.205-2.337l.347-.549a19.5,19.5,0,0,0,5.038,2.262Z",
    transform: "translate(-115.032 -864.683)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(55.737 120.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M122.865,766.806a4.923,4.923,0,0,1,4.85-1.116l10.354,3.242a4.925,4.925,0,0,1-2.944,9.4l-10.354-3.242a4.926,4.926,0,0,1-1.908-8.284Z",
    transform: "translate(-120.991 -765.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M136.429,778.71a5.278,5.278,0,0,1-1.575-.242L124.5,775.227a5.25,5.25,0,1,1,3.138-10.021l10.354,3.242a5.252,5.252,0,0,1-1.562,10.262Zm-10.357-13.094a4.61,4.61,0,0,0-3.16,1.252h0a4.6,4.6,0,0,0,1.782,7.739l10.354,3.242a4.6,4.6,0,1,0,2.749-8.781l-10.354-3.242A4.585,4.585,0,0,0,126.072,765.616Z",
    transform: "translate(-120.815 -764.967)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(54.342 130.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M120.716,781.562a4.923,4.923,0,0,1,4.85-1.115l10.354,3.242a4.925,4.925,0,0,1-2.944,9.4l-10.354-3.242a4.927,4.927,0,0,1-1.908-8.285Z",
    transform: "translate(-118.842 -779.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M134.279,793.467a5.277,5.277,0,0,1-1.575-.242l-10.354-3.242a5.25,5.25,0,1,1,3.137-10.02l10.354,3.242a5.252,5.252,0,0,1-1.563,10.263Zm-10.357-13.095a4.61,4.61,0,0,0-3.159,1.252h0a4.6,4.6,0,0,0,1.782,7.738l10.354,3.242a4.6,4.6,0,0,0,2.749-8.781l-10.354-3.242A4.587,4.587,0,0,0,123.922,780.373Z",
    transform: "translate(-118.667 -779.723)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(58.903 111.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M128.154,752.156a4.919,4.919,0,0,1,4.358-.789l8.238,2.434a4.925,4.925,0,1,1-2.791,9.447l-8.238-2.434a4.926,4.926,0,0,1-1.567-8.659Z",
    transform: "translate(-125.865 -750.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M139.177,763.6a5.232,5.232,0,0,1-1.485-.216l-8.238-2.434a5.25,5.25,0,0,1-1.67-9.229h0a5.275,5.275,0,0,1,4.645-.841l8.238,2.434a5.25,5.25,0,0,1-1.49,10.285Zm-8.248-12.288a4.568,4.568,0,0,0-2.755.929h0a4.6,4.6,0,0,0,1.465,8.087l8.238,2.434a4.6,4.6,0,1,0,2.606-8.823l-8.238-2.434A4.618,4.618,0,0,0,130.929,751.314Z",
    transform: "translate(-125.689 -750.67)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(41.424 129.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(1.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M101.788,780.368l10.228-.713c2.247-.156,4.385,1.979,4.774,4.771s-1.117,5.18-3.364,5.338l-12.822.893",
    transform: "translate(-100.605 -779.647)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(0 10.517)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x1: 3.016,
    transform: "translate(0 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 3.016,
    height: 0.65
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(43.23 129.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M101.579,780.09l10.779-.435c2.247-.156,4.385,1.979,4.775,4.771s-1.117,5.18-3.364,5.338l-10.993.725",
    transform: "translate(-101.566 -779.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M102.79,790.638l-.042-.648,10.992-.725a3,3,0,0,0,2.154-1.163,4.953,4.953,0,0,0,.909-3.805c-.366-2.623-2.365-4.639-4.43-4.492l-10.788.435-.026-.649,10.779-.435c2.4-.169,4.7,2.1,5.109,5.051a5.6,5.6,0,0,1-1.048,4.3,3.69,3.69,0,0,1-2.615,1.4Z",
    transform: "translate(-101.559 -779.146)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(49.869 196.221)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    y1: 6.121,
    x2: 1.695,
    transform: "translate(0.312 0.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 6.351,
    height: 0.65,
    transform: "translate(0 6.122) rotate(-74.539)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(35.533 192.207)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    x1: 10.78,
    y2: 11.542,
    transform: "translate(0.239 0.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 15.794,
    height: 0.649,
    transform: "matrix(0.683, -0.731, 0.731, 0.683, 0, 11.539)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(85.994 186.031)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    x1: 2.562,
    y1: 5.812,
    transform: "translate(0.297 0.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 0.649,
    height: 6.352,
    transform: "matrix(0.915, -0.403, 0.403, 0.915, 0, 0.262)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(90.796 181.3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x2: 12.336,
    y2: 9.863,
    transform: "translate(0.203 0.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 0.649,
    height: 15.794,
    transform: "translate(0 0.507) rotate(-51.357)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(25.757 4.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M80.179,683.927c-5.345-17.372-7.582-29.632-3.2-40.889,4.663-11.974,15.3-18.435,27.7-25.039.486-2.5-1.3-9.817-5.623-17.238L124.3,586.035c4.013,6.88,12.867,24.577,8.407,40.271a28.049,28.049,0,0,1-14.166,17.424c-3.61,1.921-13.2,7.024-14.327,9.915-1.028,2.641.284,9.937,3.9,21.688Zm24.79-66.093Z",
    transform: "translate(-74.656 -586.035)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 56.316,
    cy: 10.424,
    rx: 56.316,
    ry: 10.424
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(0 -111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-16.151)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(13.769 5495.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    transform: "translate(51.031 164.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 27.829,
    cy: 27.829,
    r: 27.829,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M134.6,2470.194a28.154,28.154,0,1,1,28.153-28.154A28.186,28.186,0,0,1,134.6,2470.194Zm0-55.658a27.5,27.5,0,1,0,27.5,27.5A27.535,27.535,0,0,0,134.6,2414.536Z",
    transform: "translate(-106.445 -2413.887)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(19.481 17.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(8.348)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    y2: 24.028,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M149.617,2465.5a.324.324,0,0,1-.325-.324v-24.028a.325.325,0,0,1,.65,0v24.028A.325.325,0,0,1,149.617,2465.5Z",
    transform: "translate(-149.292 -2440.819)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(0 0.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 1.325,
    cy: 1.325,
    r: 1.325
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(14.694)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 1.325,
    cy: 1.325,
    r: 1.325
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(33.526 15.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M164.145,2442.865a.65.65,0,0,1-.4-.136l-5.432-4.195a.65.65,0,1,1,.794-1.028l5.433,4.194a.65.65,0,0,1-.4,1.164Z",
    transform: "translate(-158.063 -2437.371)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(15.809 15.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M131.435,2442.865a.65.65,0,0,1-.4-1.164l5.433-4.194a.65.65,0,1,1,.794,1.028l-5.434,4.195A.646.646,0,0,1,131.435,2442.865Z",
    transform: "translate(-130.785 -2437.371)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(172.553 115.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 26.083,
    cy: 26.083,
    r: 26.083,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M319.951,2390.6a26.408,26.408,0,1,1,26.408-26.408A26.438,26.438,0,0,1,319.951,2390.6Zm0-52.166a25.758,25.758,0,1,0,25.759,25.758A25.787,25.787,0,0,0,319.951,2338.431Z",
    transform: "translate(-293.544 -2337.782)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    transform: "translate(14.602 16.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(11.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    y2: 22.521,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M334.027,2386.194a.324.324,0,0,1-.325-.325v-22.521a.325.325,0,0,1,.65,0v22.521A.324.324,0,0,1,334.027,2386.194Z",
    transform: "translate(-333.702 -2363.024)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(3.749 4.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 1.242,
    cy: 1.242,
    r: 1.242
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390",
    transform: "translate(13.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 1.242,
    cy: 1.242,
    r: 1.242
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(15.707 0.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M340.858,2367.533a.65.65,0,0,1-.223-1.26l6.38-2.333a.649.649,0,1,1,.446,1.22l-6.381,2.333A.637.637,0,0,1,340.858,2367.533Z",
    transform: "translate(-340.209 -2363.901)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(0 0.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M323.056,2367.738a.643.643,0,0,1-.19-.029l-6.381-1.955a.649.649,0,1,1,.381-1.242l6.381,1.955a.65.65,0,0,1-.19,1.271Z",
    transform: "translate(-316.025 -2364.484)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    transform: "translate(197.123 138.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 32.231,
    cy: 32.231,
    r: 32.231,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M363.93,2438.4a32.556,32.556,0,1,1,32.556-32.556A32.593,32.593,0,0,1,363.93,2438.4Zm0-64.463a31.906,31.906,0,1,0,31.906,31.907A31.943,31.943,0,0,0,363.93,2373.934Z",
    transform: "translate(-331.374 -2373.284)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(21.198 20.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    transform: "translate(11.033)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    y2: 15.841,
    transform: "translate(0.324 0.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M381.324,2420.967a.324.324,0,0,1-.325-.324V2404.8a.325.325,0,0,1,.649,0v15.841A.325.325,0,0,1,381.324,2420.967Z",
    transform: "translate(-380.999 -2404.477)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401",
    transform: "translate(0 0.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 1.535,
    cy: 1.535,
    r: 1.535
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(19.646)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 1.535,
    cy: 1.535,
    r: 1.535
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(93.136 135.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 33.409,
    cy: 33.409,
    r: 33.409,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M205,2435.992a33.734,33.734,0,1,1,33.734-33.733A33.771,33.771,0,0,1,205,2435.992Zm0-66.818a33.084,33.084,0,1,0,33.084,33.084A33.122,33.122,0,0,0,205,2369.174Z",
    transform: "translate(-171.271 -2368.525)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(21.961 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    transform: "translate(11.448)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    y2: 17.814,
    transform: "translate(0.325 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M223.033,2419.32a.325.325,0,0,1-.325-.325v-17.814a.325.325,0,0,1,.65,0V2419A.324.324,0,0,1,223.033,2419.32Z",
    transform: "translate(-222.708 -2400.857)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408",
    transform: "translate(0 0.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 1.591,
    cy: 1.591,
    r: 1.591
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(20.364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 1.591,
    cy: 1.591,
    r: 1.591
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(11.855 18.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M224.415,2434.725a4.481,4.481,0,0,1-.815-.076.325.325,0,1,1,.119-.639,3.749,3.749,0,0,0,4.34-4.521.325.325,0,0,1,.633-.146,4.4,4.4,0,0,1-4.278,5.381Z",
    transform: "translate(-223.335 -2429.092)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419",
    transform: "translate(132.91 113.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 24.605,
    cy: 24.605,
    r: 24.605,
    transform: "translate(0.325 0.324)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M257.439,2384.045a24.929,24.929,0,1,1,24.929-24.929A24.958,24.958,0,0,1,257.439,2384.045Zm0-49.209a24.28,24.28,0,1,0,24.279,24.28A24.307,24.307,0,0,0,257.439,2334.836Z",
    transform: "translate(-232.509 -2334.187)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418",
    transform: "translate(16.259 15.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(8.346)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    y2: 13.119,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M270.717,2371.767a.325.325,0,0,1-.325-.325v-13.119a.325.325,0,0,1,.649,0v13.119A.325.325,0,0,1,270.717,2371.767Z",
    transform: "translate(-270.392 -2357.998)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(0 0.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 1.172,
    cy: 1.172,
    r: 1.172
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(14.997)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 1.172,
    cy: 1.172,
    r: 1.172
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(8.645 13.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M271.728,2383.111a3.268,3.268,0,0,1-.61-.057.325.325,0,1,1,.119-.638,2.676,2.676,0,0,0,3.1-3.227.325.325,0,0,1,.633-.146,3.327,3.327,0,0,1-3.24,4.067Z",
    transform: "translate(-270.853 -2378.792)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(250.802 154.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 25.41,
    cy: 25.41,
    r: 25.41,
    transform: "translate(0.325 0.324)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M439.754,2449.78a25.734,25.734,0,1,1,25.735-25.734A25.763,25.763,0,0,1,439.754,2449.78Zm0-50.82a25.085,25.085,0,1,0,25.085,25.085A25.113,25.113,0,0,0,439.754,2398.96Z",
    transform: "translate(-414.019 -2398.311)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426",
    transform: "translate(16.781 15.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(8.63)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    y2: 13.549,
    transform: "translate(0.324 0.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M453.467,2437.1a.325.325,0,0,1-.325-.325v-13.548a.325.325,0,0,1,.649,0v13.548A.325.325,0,0,1,453.467,2437.1Z",
    transform: "translate(-453.142 -2422.902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(0 0.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 1.21,
    cy: 1.21,
    r: 1.21
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(15.488)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 1.21,
    cy: 1.21,
    r: 1.21
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425",
    transform: "translate(8.939 13.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M454.517,2448.816a3.512,3.512,0,0,1-.634-.058.325.325,0,0,1,.119-.639,2.774,2.774,0,0,0,3.211-3.345.325.325,0,1,1,.633-.145,3.424,3.424,0,0,1-3.329,4.188Z",
    transform: "translate(-453.618 -2444.376)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(72.912 88.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M194.927,2337.569a.325.325,0,0,1-.229-.095l-6.224-6.224a11.691,11.691,0,0,1-5.045,1.126H147.078a11.823,11.823,0,1,1,0-23.647h36.351a11.824,11.824,0,0,1,11.823,11.824v16.691a.325.325,0,0,1-.325.325Zm-6.387-7.037a.325.325,0,0,1,.23.095l5.833,5.833v-15.907a11.174,11.174,0,0,0-11.173-11.174H147.078a11.174,11.174,0,0,0,0,22.348h36.351a11.05,11.05,0,0,0,4.967-1.16A.323.323,0,0,1,188.54,2330.532Z",
    transform: "translate(-135.254 -2308.729)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(20.738 9.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 2.079,
    cy: 2.079,
    r: 2.079
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(7.182)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 2.079,
    cy: 2.079,
    r: 2.079
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(14.365)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 2.079,
    cy: 2.079,
    r: 2.079
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436",
    transform: "translate(290.429 128.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(12.914 7.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M497.345,2370.6a.889.889,0,0,0-.615-.2.918.918,0,0,0-.666.233.789.789,0,0,0-.241.594.736.736,0,0,0,.277.607,2.275,2.275,0,0,0,.76.365,3.593,3.593,0,0,1,.779.318,1.852,1.852,0,0,1,.5.406,1.379,1.379,0,0,1,.27.493,2.05,2.05,0,0,1,.081.584,1.721,1.721,0,0,1-.108.6,1.6,1.6,0,0,1-.864.912,1.809,1.809,0,0,1-.748.145,1.955,1.955,0,0,1-1.185-.362,1.853,1.853,0,0,1-.671-1.133h.731a1.332,1.332,0,0,0,.394.667,1.073,1.073,0,0,0,.74.249,1.048,1.048,0,0,0,.454-.093.942.942,0,0,0,.325-.241,1,1,0,0,0,.193-.333,1.121,1.121,0,0,0,.064-.37.994.994,0,0,0-.289-.747,2.194,2.194,0,0,0-.884-.466,2.646,2.646,0,0,1-1.126-.611,1.352,1.352,0,0,1-.37-.989,1.312,1.312,0,0,1,.116-.546,1.384,1.384,0,0,1,.326-.45,1.494,1.494,0,0,1,.5-.3,1.814,1.814,0,0,1,.642-.109,1.834,1.834,0,0,1,.62.1,1.565,1.565,0,0,1,.49.277,1.481,1.481,0,0,1,.342.415,1.457,1.457,0,0,1,.173.51h-.715A.925.925,0,0,0,497.345,2370.6Z",
    transform: "translate(-494.914 -2369.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M501.726,2373.636a1.947,1.947,0,0,1,.434-.651,1.982,1.982,0,0,1,.655-.426,2.251,2.251,0,0,1,1.64,0,2,2,0,0,1,.651.431,1.936,1.936,0,0,1,.426.651,2.14,2.14,0,0,1,.153.812,2.088,2.088,0,0,1-.153.8,2.006,2.006,0,0,1-.43.655,2.076,2.076,0,0,1-.655.446,2.019,2.019,0,0,1-.82.165,2.058,2.058,0,0,1-1.467-.6,1.985,1.985,0,0,1-.434-.655,2.2,2.2,0,0,1,0-1.632Zm.614,1.419a1.512,1.512,0,0,0,.305.47,1.345,1.345,0,0,0,.981.418,1.4,1.4,0,0,0,.562-.112,1.317,1.317,0,0,0,.442-.314,1.456,1.456,0,0,0,.289-.474,1.633,1.633,0,0,0,.1-.587,1.616,1.616,0,0,0-.1-.575,1.442,1.442,0,0,0-.281-.47,1.3,1.3,0,0,0-.442-.318,1.469,1.469,0,0,0-1.137,0,1.328,1.328,0,0,0-.442.31,1.423,1.423,0,0,0-.289.466,1.612,1.612,0,0,0-.1.591A1.546,1.546,0,0,0,502.341,2375.055Z",
    transform: "translate(-497.247 -2370.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M514.687,2372.6a1.82,1.82,0,0,1,.59.49,1.917,1.917,0,0,1,.325.647,2.449,2.449,0,0,1,.1.667c0,.037,0,.081,0,.129a.553.553,0,0,1-.012.1h-3.142a1.156,1.156,0,0,0,.112.5,1.4,1.4,0,0,0,.3.418,1.5,1.5,0,0,0,.434.29,1.273,1.273,0,0,0,.518.108,1.223,1.223,0,0,0,.575-.121,1.339,1.339,0,0,0,.414-.345h.732a2.091,2.091,0,0,1-.246.366,1.761,1.761,0,0,1-.362.329,1.867,1.867,0,0,1-1.1.334,2.114,2.114,0,0,1-.836-.16,1.858,1.858,0,0,1-.643-.446,2.075,2.075,0,0,1-.414-.672,2.3,2.3,0,0,1-.149-.836,2.152,2.152,0,0,1,.136-.759,1.962,1.962,0,0,1,.386-.639,1.885,1.885,0,0,1,.6-.438,2.037,2.037,0,0,1,1.676.032Zm-1.383.455a1.21,1.21,0,0,0-.635.627,1.459,1.459,0,0,0-.116.426h2.484a1.392,1.392,0,0,0-.121-.435,1.223,1.223,0,0,0-.257-.366,1.281,1.281,0,0,0-.377-.253,1.176,1.176,0,0,0-.483-.1A1.227,1.227,0,0,0,513.3,2373.058Z",
    transform: "translate(-500.863 -2370.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M522.052,2376.386v-.514h-.016a1.9,1.9,0,0,1-.562.454,1.708,1.708,0,0,1-.844.2,1.987,1.987,0,0,1-.751-.144,1.9,1.9,0,0,1-.631-.418,2.055,2.055,0,0,1-.434-.651,2.3,2.3,0,0,1-.008-1.672,1.936,1.936,0,0,1,.425-.651,1.975,1.975,0,0,1,.639-.426,2.053,2.053,0,0,1,.8-.153,1.6,1.6,0,0,1,.474.064,1.888,1.888,0,0,1,.377.16,1.6,1.6,0,0,1,.3.218,2.25,2.25,0,0,1,.225.241h.008v-.555h.635v3.85Zm-2.656-1.378a1.345,1.345,0,0,0,1.322.952,1.3,1.3,0,0,0,.522-.108,1.384,1.384,0,0,0,.442-.305,1.514,1.514,0,0,0,.309-.466,1.485,1.485,0,0,0,.117-.6,1.7,1.7,0,0,0-.108-.623,1.494,1.494,0,0,0-.3-.479,1.316,1.316,0,0,0-.969-.417,1.451,1.451,0,0,0-.631.129,1.25,1.25,0,0,0-.442.342,1.5,1.5,0,0,0-.262.482,1.742,1.742,0,0,0-.088.542A1.826,1.826,0,0,0,519.4,2375.008Z",
    transform: "translate(-503.234 -2370.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M528.057,2373.09a.6.6,0,0,0-.4-.145.625.625,0,0,0-.454.152.49.49,0,0,0-.157.362.535.535,0,0,0,.029.173.4.4,0,0,0,.117.166,1.276,1.276,0,0,0,.245.165,2.357,2.357,0,0,0,.422.164,2.476,2.476,0,0,1,.535.237,1.412,1.412,0,0,1,.342.29,1.019,1.019,0,0,1,.184.333,1.209,1.209,0,0,1,.057.37,1.083,1.083,0,0,1-.354.848,1.364,1.364,0,0,1-.948.318,1.627,1.627,0,0,1-.562-.088,1.188,1.188,0,0,1-.41-.245,1.231,1.231,0,0,1-.273-.37,1.817,1.817,0,0,1-.153-.462h.644a.863.863,0,0,0,.237.438.735.735,0,0,0,.542.18.646.646,0,0,0,.483-.164.558.558,0,0,0,.16-.406.743.743,0,0,0-.032-.225.486.486,0,0,0-.128-.2,1.033,1.033,0,0,0-.266-.181,3.385,3.385,0,0,0-.434-.173,1.838,1.838,0,0,1-.8-.459,1.015,1.015,0,0,1-.257-.715,1.056,1.056,0,0,1,.076-.4.934.934,0,0,1,.229-.333,1.1,1.1,0,0,1,.377-.229,1.493,1.493,0,0,1,.523-.084,1.459,1.459,0,0,1,.518.084,1.149,1.149,0,0,1,.377.229,1.164,1.164,0,0,1,.253.333,1.711,1.711,0,0,1,.145.406h-.643A.65.65,0,0,0,528.057,2373.09Z",
    transform: "translate(-505.905 -2370.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M531.7,2378.344l.7-1.889-1.415-3.85h.651l.812,2.242c.016.048.037.107.064.177s.052.144.076.221l.069.226c.021.072.037.135.048.189h.016q.064-.209.128-.406c.043-.132.089-.267.137-.406l.8-2.242h.643l-2.122,5.739Z",
    transform: "translate(-507.557 -2370.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M537.839,2374.055h-.579l-.064-3.963h.708Zm.064.812v.707h-.708v-.707Z",
    transform: "translate(-509.733 -2369.916)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M475.356,2384.448a.318.318,0,0,1-.125-.025.325.325,0,0,1-.2-.3v-15.065a10.7,10.7,0,0,1,10.7-10.7h32.808a10.7,10.7,0,1,1,0,21.405H485.733a10.587,10.587,0,0,1-4.547-1.01l-5.6,5.6A.323.323,0,0,1,475.356,2384.448Zm10.378-25.443a10.053,10.053,0,0,0-10.053,10.053v14.281l5.21-5.211a.326.326,0,0,1,.374-.061,9.944,9.944,0,0,0,4.469,1.044h32.808a10.053,10.053,0,1,0,0-20.107Z",
    transform: "translate(-475.031 -2358.356)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439",
    transform: "translate(8.375 127.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437",
    transform: "translate(12.435 8.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M47.774,2375.645v6.2H47.02v-6.2Z",
    transform: "translate(-47.02 -2375.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M56.315,2378.389a2.11,2.11,0,0,1,.586.318,1.646,1.646,0,0,1,.568.818h-.8a1.083,1.083,0,0,0-.414-.455,1.38,1.38,0,0,0-.75-.182,1.7,1.7,0,0,0-.591.1,1.331,1.331,0,0,0-.49.319,1.587,1.587,0,0,0-.336.531,1.973,1.973,0,0,0-.127.737,1.9,1.9,0,0,0,.118.681,1.609,1.609,0,0,0,.332.536,1.521,1.521,0,0,0,.5.354,1.561,1.561,0,0,0,.637.127,1.206,1.206,0,0,0,.781-.223,1.419,1.419,0,0,0,.4-.5h.8a2.084,2.084,0,0,1-.241.486,1.841,1.841,0,0,1-.4.431,2.059,2.059,0,0,1-.572.314,2.226,2.226,0,0,1-.777.123,2.44,2.44,0,0,1-.932-.173,2.247,2.247,0,0,1-.736-.482,2.144,2.144,0,0,1-.486-.74,2.656,2.656,0,0,1-.014-1.844,2.128,2.128,0,0,1,1.181-1.231,2.386,2.386,0,0,1,.95-.182A2.336,2.336,0,0,1,56.315,2378.389Z",
    transform: "translate(-49.192 -2376.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M64.655,2382.76v-.582h-.018a2.161,2.161,0,0,1-.637.514,1.928,1.928,0,0,1-.954.223,2.243,2.243,0,0,1-.85-.164,2.12,2.12,0,0,1-.714-.472,2.3,2.3,0,0,1-.49-.736,2.607,2.607,0,0,1-.009-1.89,2.188,2.188,0,0,1,.481-.737,2.221,2.221,0,0,1,.723-.481,2.319,2.319,0,0,1,.9-.173,1.806,1.806,0,0,1,.536.073,2.081,2.081,0,0,1,.427.182,1.8,1.8,0,0,1,.336.245,2.665,2.665,0,0,1,.255.273h.008v-.626h.718v4.353Zm-3-1.559a1.532,1.532,0,0,0,.3.541,1.553,1.553,0,0,0,.5.386,1.533,1.533,0,0,0,.7.15,1.463,1.463,0,0,0,.59-.123,1.583,1.583,0,0,0,.5-.345,1.729,1.729,0,0,0,.35-.527,1.688,1.688,0,0,0,.132-.677,1.918,1.918,0,0,0-.123-.7,1.665,1.665,0,0,0-.336-.541,1.483,1.483,0,0,0-1.1-.473,1.649,1.649,0,0,0-.714.145,1.443,1.443,0,0,0-.5.386,1.705,1.705,0,0,0-.3.545,1.97,1.97,0,0,0-.1.614A2.062,2.062,0,0,0,61.651,2381.2Z",
    transform: "translate(-51.854 -2376.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M70.481,2378.407v.544H70.5a1.64,1.64,0,0,1,.659-.54,1.835,1.835,0,0,1,.713-.15,1.911,1.911,0,0,1,.6.1,1.45,1.45,0,0,1,.55.331,1.783,1.783,0,0,1,.4.6,2.371,2.371,0,0,1,.159.927v2.536h-.718v-2.49a1.53,1.53,0,0,0-.3-1.013,1.007,1.007,0,0,0-.813-.351,1.2,1.2,0,0,0-.936.387,1.676,1.676,0,0,0-.346,1.15v2.317h-.718v-4.353Z",
    transform: "translate(-54.991 -2376.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M78.337,2375.113v.446a2.834,2.834,0,0,1-.127.882,3.09,3.09,0,0,1-.309.682h-.454a1.675,1.675,0,0,0,.227-.537,3.662,3.662,0,0,0,.082-.572h-.327v-.9Z",
    transform: "translate(-57.678 -2375.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M80.545,2377.736v-1.391h.718v1.391h1.163v.6H81.264v2.3a1.994,1.994,0,0,0,.041.441.633.633,0,0,0,.127.277.467.467,0,0,0,.214.141,1,1,0,0,0,.3.041,1.976,1.976,0,0,0,.527-.072v.59a2.149,2.149,0,0,1-.672.091,1.45,1.45,0,0,1-.646-.123.933.933,0,0,1-.381-.336,1.269,1.269,0,0,1-.182-.49,3.6,3.6,0,0,1-.046-.587v-2.272h-.572v-.6Z",
    transform: "translate(-58.57 -2375.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M88.727,2377.279v-.782a1.54,1.54,0,0,1,.346-1.077,1.324,1.324,0,0,1,1.027-.378,2.027,2.027,0,0,1,.536.073v.6a1.074,1.074,0,0,0-.24-.06,2.18,2.18,0,0,0-.25-.013.626.626,0,0,0-.523.214.879.879,0,0,0-.168.559v.864h1v.6h-1v3.753h-.727v-3.753H88.1v-.6Z",
    transform: "translate(-61.418 -2375.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M93.62,2375.575v.845h-.891v-.845Zm-.091,1.891v4.353h-.718v-4.353Z",
    transform: "translate(-63.041 -2375.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M96.609,2378.407v.544h.018a1.64,1.64,0,0,1,.659-.54,1.835,1.835,0,0,1,.713-.15,1.911,1.911,0,0,1,.6.1,1.45,1.45,0,0,1,.55.331,1.783,1.783,0,0,1,.4.6,2.371,2.371,0,0,1,.159.927v2.536H99v-2.49a1.53,1.53,0,0,0-.3-1.013,1.008,1.008,0,0,0-.813-.351,1.2,1.2,0,0,0-.936.387,1.676,1.676,0,0,0-.346,1.15v2.317h-.718v-4.353Z",
    transform: "translate(-64.149 -2376.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M107.008,2381.657v-.582h-.018a2.15,2.15,0,0,1-.641.513,2.013,2.013,0,0,1-.986.223,2.212,2.212,0,0,1-.845-.164,2.036,2.036,0,0,1-.7-.473,2.321,2.321,0,0,1-.477-.736,2.646,2.646,0,0,1-.009-1.881,2.279,2.279,0,0,1,.459-.736,2.094,2.094,0,0,1,.7-.486,2.16,2.16,0,0,1,.877-.177,2.292,2.292,0,0,1,.549.059,1.9,1.9,0,0,1,.432.159,1.718,1.718,0,0,1,.35.24,2.874,2.874,0,0,1,.3.3h.018v-2.808h.718v6.544Zm-3-1.559a1.612,1.612,0,0,0,.3.541,1.56,1.56,0,0,0,.495.386,1.489,1.489,0,0,0,.687.15,1.516,1.516,0,0,0,.6-.123,1.57,1.57,0,0,0,.85-.868,1.778,1.778,0,0,0,.127-.681,1.914,1.914,0,0,0-.123-.7,1.708,1.708,0,0,0-.332-.541,1.427,1.427,0,0,0-.5-.35,1.535,1.535,0,0,0-.613-.123,1.588,1.588,0,0,0-.7.146,1.507,1.507,0,0,0-.5.382,1.6,1.6,0,0,0-.3.541,1.986,1.986,0,0,0,0,1.245Z",
    transform: "translate(-66.698 -2375.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M116.377,2375.575v.845h-.89v-.845Zm-.091,1.891v4.353h-.718v-4.353Z",
    transform: "translate(-71.017 -2375.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M118.493,2377.736v-1.391h.718v1.391h1.163v.6h-1.163v2.3a1.994,1.994,0,0,0,.041.441.64.64,0,0,0,.127.277.467.467,0,0,0,.214.141,1,1,0,0,0,.3.041,1.981,1.981,0,0,0,.527-.072v.59a2.153,2.153,0,0,1-.673.091,1.45,1.45,0,0,1-.646-.123.937.937,0,0,1-.381-.336,1.28,1.28,0,0,1-.182-.49,3.6,3.6,0,0,1-.045-.587v-2.272h-.573v-.6Z",
    transform: "translate(-71.87 -2375.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M123.879,2380.125h-.654l-.073-4.48h.8Zm.073.918v.8h-.8v-.8Z",
    transform: "translate(-73.704 -2375.254)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M103.906,2391.857a.324.324,0,0,1-.23-.095l-6.355-6.354a11.927,11.927,0,0,1-5.15,1.15H39.934a12.059,12.059,0,0,1,0-24.119H92.172a12.06,12.06,0,0,1,12.059,12.06v17.033a.326.326,0,0,1-.2.3A.32.32,0,0,1,103.906,2391.857Zm-6.518-7.167a.325.325,0,0,1,.229.1l5.964,5.964V2374.5a11.411,11.411,0,0,0-11.41-11.41H39.934a11.41,11.41,0,0,0,0,22.82H92.172a11.288,11.288,0,0,0,5.071-1.185A.318.318,0,0,1,97.388,2384.689Z",
    transform: "translate(-27.875 -2362.439)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442",
    transform: "translate(237.662 102.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M394.114,2350.378a.318.318,0,0,1-.125-.026.323.323,0,0,1-.2-.3v-18.446a13.032,13.032,0,0,1,13.032-13.032H422.4a13.032,13.032,0,0,1,0,26.063H406.821a12.893,12.893,0,0,1-5.583-1.251l-6.894,6.895A.325.325,0,0,1,394.114,2350.378Zm12.707-31.153a12.383,12.383,0,0,0-12.382,12.382v17.662l6.5-6.5a.325.325,0,0,1,.374-.061,12.253,12.253,0,0,0,5.5,1.286H422.4a12.382,12.382,0,1,0,0-24.764Z",
    transform: "translate(-393.789 -2318.576)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441",
    transform: "translate(16.492 9.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M421.838,2336.6a1.475,1.475,0,0,0-.177.3,1.442,1.442,0,0,0-.1.329,2.213,2.213,0,0,0-.03.38h-.718q0-.266.02-.487a1.97,1.97,0,0,1,.079-.413,1.793,1.793,0,0,1,.167-.379,2.335,2.335,0,0,1,.285-.384c.138-.157.264-.3.379-.418a3.155,3.155,0,0,0,.3-.359,1.676,1.676,0,0,0,.192-.359,1.173,1.173,0,0,0,.069-.418,1.277,1.277,0,0,0-.073-.438,1,1,0,0,0-.222-.354,1.056,1.056,0,0,0-.359-.241,1.251,1.251,0,0,0-.487-.089,1.2,1.2,0,0,0-.433.079,1,1,0,0,0-.359.231,1.085,1.085,0,0,0-.241.374,1.311,1.311,0,0,0-.089.5h-.856a2.017,2.017,0,0,1,.167-.778,1.828,1.828,0,0,1,.429-.6,1.929,1.929,0,0,1,.635-.389,2.181,2.181,0,0,1,.777-.137,2.3,2.3,0,0,1,.861.148,1.741,1.741,0,0,1,.61.394,1.63,1.63,0,0,1,.364.565,1.844,1.844,0,0,1,.123.665,2.048,2.048,0,0,1-.1.65,2.336,2.336,0,0,1-.256.536,3.315,3.315,0,0,1-.34.438q-.182.2-.349.364A2.94,2.94,0,0,0,421.838,2336.6Zm-.236,2v.866h-.866v-.866Z",
    transform: "translate(-419.181 -2332.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M430.078,2336.6a1.428,1.428,0,0,0-.276.629,2.276,2.276,0,0,0-.029.38h-.718q0-.266.02-.487a2.014,2.014,0,0,1,.079-.413,1.833,1.833,0,0,1,.168-.379,2.331,2.331,0,0,1,.285-.384c.138-.157.264-.3.379-.418a3.139,3.139,0,0,0,.295-.359,1.654,1.654,0,0,0,.192-.359,1.189,1.189,0,0,0,.069-.418,1.262,1.262,0,0,0-.074-.438.986.986,0,0,0-.221-.354,1.052,1.052,0,0,0-.359-.241,1.247,1.247,0,0,0-.487-.089,1.2,1.2,0,0,0-.433.079,1,1,0,0,0-.359.231,1.086,1.086,0,0,0-.242.374,1.325,1.325,0,0,0-.088.5h-.856a2.019,2.019,0,0,1,.167-.778,1.836,1.836,0,0,1,.428-.6,1.943,1.943,0,0,1,.635-.389,2.182,2.182,0,0,1,.778-.137,2.3,2.3,0,0,1,.861.148,1.75,1.75,0,0,1,.611.394,1.64,1.64,0,0,1,.364.565,1.832,1.832,0,0,1,.123.665,2.028,2.028,0,0,1-.1.65,2.31,2.31,0,0,1-.256.536,3.208,3.208,0,0,1-.34.438c-.121.131-.238.253-.349.364A2.867,2.867,0,0,0,430.078,2336.6Zm-.236,2v.866h-.866v-.866Z",
    transform: "translate(-422.069 -2332.54)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(163.222 75.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M279.5,2308.657a.326.326,0,0,1-.325-.325v-19.259a13.592,13.592,0,0,1,13.591-13.591h16.262a13.592,13.592,0,0,1,0,27.183H292.77a13.448,13.448,0,0,1-5.832-1.31l-7.206,7.206A.323.323,0,0,1,279.5,2308.657Zm13.267-32.525a12.943,12.943,0,0,0-12.942,12.942v18.475l6.815-6.815a.325.325,0,0,1,.375-.061,12.8,12.8,0,0,0,5.753,1.344h16.262a12.942,12.942,0,0,0,0-25.884Z",
    transform: "translate(-279.178 -2275.483)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446",
    transform: "translate(14.809 6.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M309.664,2300.122a7.685,7.685,0,1,1,7.684-7.685A7.694,7.694,0,0,1,309.664,2300.122Zm0-14.719a7.035,7.035,0,1,0,7.035,7.035A7.043,7.043,0,0,0,309.664,2285.4Z",
    transform: "translate(-301.979 -2284.753)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(2.99 4.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M310.127,2298.11a.328.328,0,0,1-.244-.111l-3.22-3.68a.325.325,0,1,1,.489-.428l2.971,3.4,4.815-5.692a.325.325,0,0,1,.5.42l-5.06,5.979a.325.325,0,0,1-.246.115Z",
    transform: "translate(-306.582 -2291.481)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(139.665 147.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 37.156,
    cy: 37.156,
    r: 37.156,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M280.39,2461.631a37.481,37.481,0,1,1,37.48-37.481A37.523,37.523,0,0,1,280.39,2461.631Zm0-74.311a36.831,36.831,0,1,0,36.831,36.83A36.873,36.873,0,0,0,280.39,2387.319Z",
    transform: "translate(-242.909 -2386.669)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(24.388 23.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(12.769)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    y2: 30.478,
    transform: "translate(0.324 0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M300.441,2453.756a.324.324,0,0,1-.325-.325v-30.479a.325.325,0,0,1,.65,0v30.479A.324.324,0,0,1,300.441,2453.756Z",
    transform: "translate(-300.116 -2422.628)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452",
    transform: "translate(0 0.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 1.769,
    cy: 1.769,
    r: 1.769
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(22.647)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 1.769,
    cy: 1.769,
    r: 1.769
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(225.107 179.543)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 4.158,
    cy: 4.158,
    r: 4.158,
    transform: "translate(0.325 0.325)",
    fill: "#fffaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M378.942,2445.4a4.483,4.483,0,1,1,4.483-4.483A4.488,4.488,0,0,1,378.942,2445.4Zm0-8.316a3.833,3.833,0,1,0,3.833,3.833A3.838,3.838,0,0,0,378.942,2437.081Z",
    transform: "translate(-374.459 -2436.432)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(299.716 48.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M489.655,2307.443a.324.324,0,0,1-.325-.324v-3.247a.325.325,0,0,1,.65,0v3.247A.324.324,0,0,1,489.655,2307.443Zm0-9.741a.324.324,0,0,1-.325-.325v-3.247a.325.325,0,1,1,.65,0v3.247A.325.325,0,0,1,489.655,2297.7Zm0-9.743a.325.325,0,0,1-.325-.325v-3.248a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,489.655,2287.959Zm0-9.742a.325.325,0,0,1-.325-.325v-3.247a.325.325,0,1,1,.65,0v3.247A.325.325,0,0,1,489.655,2278.217Zm0-9.743a.324.324,0,0,1-.325-.325V2264.9a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,489.655,2268.474Zm0-9.742a.325.325,0,0,1-.325-.324v-3.248a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,489.655,2258.731Zm0-9.742a.324.324,0,0,1-.325-.325v-3.247a.325.325,0,1,1,.65,0v3.247A.325.325,0,0,1,489.655,2248.989Zm0-9.743a.324.324,0,0,1-.325-.325v-3.248a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,489.655,2239.246Z",
    transform: "translate(-489.33 -2235.349)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459",
    transform: "translate(233.424 69.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M387.588,2298.06a.324.324,0,0,1-.325-.325v-.824a.325.325,0,0,1,.65,0v.824A.324.324,0,0,1,387.588,2298.06Zm0-7.319a.324.324,0,0,1-.325-.324v-3.248a.325.325,0,0,1,.65,0v3.248A.324.324,0,0,1,387.588,2290.741Zm0-9.742a.324.324,0,0,1-.325-.325v-3.247a.325.325,0,0,1,.65,0v3.247A.324.324,0,0,1,387.588,2281Zm0-9.743a.324.324,0,0,1-.325-.325v-3.248a.325.325,0,0,1,.65,0v3.248A.324.324,0,0,1,387.588,2271.256Z",
    transform: "translate(-387.263 -2267.359)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    transform: "translate(178.045 22.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M302.325,2217.732a.325.325,0,0,1-.325-.325v-2.6a.325.325,0,0,1,.65,0v2.6A.325.325,0,0,1,302.325,2217.732Zm0-9.093a.325.325,0,0,1-.325-.325v-3.248a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,302.325,2208.639Zm0-9.743a.325.325,0,0,1-.325-.325v-3.248a.325.325,0,0,1,.65,0v3.248A.325.325,0,0,1,302.325,2198.9Z",
    transform: "translate(-302 -2195)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M-2597.457-6541.531h342",
    transform: "translate(2601.806 12226.531)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.75
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessMobile);
export default __webpack_public_path__ + "static/media/process_mobile.7acd7ad663b18cd3da71e6546909c6e0.svg";
export { ForwardRef as ReactComponent };